/*
 * ##############################################################################
 * Module Name                   : TransactionDet
 * Purpose of the Module         :
 * Description of the Module     :
 * Original Author               :  T A C Priyashad
 * Date                          : Thursday, October 14th 2021, 10:06:22 am
 * Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)
 * ##############################################################################
 */



import React, { useState, useEffect, useRef } from "react"
import { Row, Col, Button, Label } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPSwitch from "framework/components/DPSwitch"
import DPDropDown from "framework/components/DPDropDown"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation" // Textbox input validations
import { TXNLineDetails } from "../Transaction/Support-Widgets/DetComponents"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import {
  getProductDetailsCode,
  getTxnProductPricemode,
  GetMultiplePrices,
  UpdateUnitsWithExcel,
  findItemReferenceForNewArray,
  ValidateFreeQty,
  spQtyUploadValidation,
} from "../Transaction/TransactionController"

import TransactionVDet from "../Transaction/TransactionVDet"
import Payment from "../Transaction/payment"


import { AddTaxDetailsToTaxList, CalcualteVariantTax, CalculateTax, CalculateTaxWithTransactionRelatedTax } from "./TransactionTAX"
import ReactPaginate from "react-paginate"
import { Context } from "app-contexts/CommonContexts"
import { useContext } from "react"
import DPMultiplePricePopUp from "framework/components/DPMultiplePricePopUp"

import audioFile from "./../../../assets/audio/barcodeScan.mp3"
import audioFileProductError from "./../../../assets/audio/audioProductError.mp3"
import audioFileBalQtyError from "./../../../assets/audio/audioBalQtyError.mp3"
import DPPermission from "framework/widgets/DPPermission"
import DPLoadingAlert from "framework/widgets/DPLoadingAlert"
import TXN_QTY_Upload_Template from "../../../assets/File/TXN_QTY_Upload_Template.xlsx";

import * as XLSX from "xlsx"
import { TransactionBatchModel } from "./TransactionBatchModel"

import SOHViewModel from "./Support-Widgets/SOHViewModel"
import { FormatNumberTODecimal } from "components/helpers/FormatNumberTODecimal"
import { MENUPERMISSION_QTY_EXCEED } from "Permission_Rules"
import RemarksDrawer from "./Support-Widgets/RemarksDrawer"



const TransactionDET = ({
  menuName,
  PayDataRow,
  AddPayRow,
  RemovePayRow,
  Collapse,
  DataRow,
  SetDataRow,
  TxnTotalCal,
  RefDataRow,
  AddRow,
  RemoveRow,
  BookChange,
  DiscountPer_OnChange,
  AddAmount_OnChange,
  DedAmount_OnChange,
  DiscountPer_OnBlur,
  AddAmount_OnBlur,
  DedAmount_OnBlur,
  SupplierCode,
  blDiasableGrid,
  lineDisc,
  SetGrossTotaltx,
  SetTxDiscount,
  SetTxAddition,
  SetTxTaxInc,
  SetTxTaxExc,
  SetLineDisc,
  SetTxDeduction,
  SetTxNetAmount,
  GrossTotal,
  txDiscount,
  txDiscountAmt,
  txAddition,
  txDeduction,
  txTaxInc,
  txTaxExc,
  txNetAmount,
  show,
  AlertMsg,
  AlertColor,
  ErrorMsg,
  type,
  txn,
  supplierSelect,
  loccode,
  TaxDetails,
  taxTable,
  SetTaxtTable,
  DisableDet,
  menuCode,
  setDataForRecovery,
  Reason,
  setReason,
  setPermissionAlertShow,
  setAlertConfirmOption,
  AlertConfirmOption,
  setAlertDescription,
  setsweetAlertShow,
  PaidAmt,
  DueAmt,
  TotalPayCalculation,
  clearStatus,
  taxProductCodes,
  setTaxProductCodes,
  SetTaxLineRemarks,
  TaxLineRemarks,
  setAlertColor,
  setAlertMsg,
  setShow,
  priceModeSelect,
  SetPayDataRow,
  baseProduct,
  proSelect,
  TotalLineAmtCalcualtion,
  toLocationSelect,
  reasonForDetails,
  setReasonForDetails,
  processStat,
  RefStockFreeze,
  bomToValue,
  bomFromValue,
  RefCode,
  BomReCalculateFinishProAVGCost,
  supplierContribution,
  txnTaxTypes,
  newTaxTable,
  setNewTaxTable,
  customerSelect,
  txRefAmount,
  detailReasonTypes,
  consignmentOnClick,
  generalFields,
  exportDataToExcel,
  validToDate,
  validFromDate,
}) => {

  const {
    isHeadOffice, menus, getMenuDetails, endOfDate, txnDecimalAmt, txnDecimalQty, isWMS
  } = useContext(Context);

  const [txnUI, setTxnUI] = useState([])
  const [prefixwidth, setPrefixWidth] = useState(0)
  const [autoScan, SetAutoScan] = useState(false)
  const authToken = localStorage.getItem("authToken")

  useEffect(() => {
    SetAutoScan(false)
  }, [txn])


  //* Column Width Lenth Setting */
  const [procode, setProCode] = useState({ name: "", len: 0, width: 0 })
  const [stkcode, setStkCode] = useState({ name: "", len: 0, width: 0 })
  const [prodesc, setProDesc] = useState({ name: "", len: 0, width: 0 })
  const [prounit, setProUnit] = useState({ name: "", len: 0, width: 0 })
  const [proexpdate, setProExpDate] = useState({ name: "", len: 0, width: 0 })
  const [procost, setProCost] = useState({ name: "", len: 0, width: 0 })
  const [prosell, setProSell] = useState({ name: "", len: 0, width: 0 })
  const [productSearchFilter, setProductSearchFilter] = useState("")
  const [proweightavg, setProWeightAvg] = useState({
    name: "",
    len: 0,
    width: 0,
  })

  const [propackprice, setProPackPrice] = useState({
    name: "",
    len: 0,
    width: 0,
  })
  const [probalqty, setProBalQty] = useState({ name: "", len: 0, width: 0 })
  const [procs, setProCS] = useState({ name: "", len: 0, width: 0 })
  const [prosih, setProSIH] = useState({ name: "", len: 0, width: 0 })
  const [provar, setProVAR] = useState({ name: "", len: 0, width: 0 })
  const [procaseqty, setProCaseQty] = useState({ name: "", len: 0, width: 0 })
  const [prouniteqty, setProUnitQty] = useState({ name: "", len: 0, width: 0 })
  const [profreeunit, setProFreeUnit] = useState({ name: "", len: 0, width: 0 })
  const [profreecase, setProFreeCase] = useState({ name: "", len: 0, width: 0 })
  const [prodiscper, setProDiscPer] = useState({ name: "", len: 0, width: 0 })
  const [prodiscamt, setProDiscAmt] = useState({ name: "", len: 0, width: 0 })
  const [proamt, setProAmt] = useState({ name: "", len: 0, width: 0 })
  const [proremark, setProRemark] = useState({ name: "", len: 0, width: 0 })


  const audioRef = useRef(null)
  const audioProductErrorRef = useRef(null)
  const audioBalQtyErrorRef = useRef(null)

  const AllPara = {
    menuName,
    Collapse,
    DataRow,
    SetDataRow,
    TxnTotalCal,
    RefDataRow,
    AddRow,
    RemoveRow,
    BookChange,
    DiscountPer_OnChange,
    AddAmount_OnChange,
    DedAmount_OnChange,
    DiscountPer_OnBlur,
    AddAmount_OnBlur,
    DedAmount_OnBlur,
    SupplierCode,
    blDiasableGrid,
    lineDisc,
    SetGrossTotaltx,
    SetTxDiscount,
    SetTxAddition,
    SetTxTaxInc,
    SetTxTaxExc,
    SetLineDisc,
    SetTxDeduction,
    SetTxNetAmount,
    GrossTotal,
    txDiscount,
    txDiscountAmt,
    txAddition,
    txDeduction,
    txTaxInc,
    txTaxExc,
    txNetAmount,
    show,
    AlertMsg,
    AlertColor,
    ErrorMsg,
    type,
    txn,
    supplierSelect,
    loccode,
    TaxDetails,
    taxTable,
    SetTaxtTable,
    DisableDet,
    menuCode,
    setDataForRecovery,
    Reason,
    setReason,
    setPermissionAlertShow,
    setAlertConfirmOption,
    AlertConfirmOption,
    priceModeSelect
  }
  //* End Column Width Lenth Setting */


  const [page, setPage] = useState(1) //current page
  const [searchString, setSearchString] = useState('')
  const [searchElement, setElement] = useState("strDET_PROCODE")
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by Product Code")
  const [taxDetails, setTaxDetails] = useState(true)
  const [pageSize, setPageSize] = useState(10)
  const fileInputRef = useRef(null);
  const [currentTxnType, setCurrentTxnType] = useState("")

  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")

  const handlePageClick = (event) => {
    setPage(event.selected + 1);
  };

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {

    if (DataRow.some(row => row.strDET_PROCODE != '' && row.strDET_STOCKCODE != '')) {
      setDrawerOpen(!drawerOpen);
    }


  };

  const SearchFilteredDataTable = DataRow.filter((value) => {
    return value[searchElement].toLowerCase().includes(searchString.toLowerCase())
  })

  const indexOfLastPost = page * pageSize
  const indexOfFirstPost = indexOfLastPost - pageSize
  const currentDetailRows = SearchFilteredDataTable.slice(indexOfFirstPost, indexOfLastPost)


  currentDetailRows.reduce((acc, row) => {
    const tax = taxTable.filter((tax) => tax.detailRowID == row.id);
    return [...acc, ...tax];
  }, []);

  const currentTax = currentDetailRows.reduce((acc, row) => {
    const filteredTaxes = taxTable.filter((tax) => tax.detailRowID == row.id);
    filteredTaxes.forEach((tax) => acc.push(tax));
    return acc;
  }, []);

  useEffect(() => {
    if (currentDetailRows.length == 0 && DataRow.length > 0 && page > 1 && searchString == '') {
      setPage(prev => prev - 1)
    }
  }, [currentDetailRows])

  useEffect(() => {
    setSearchString('')
    setPage(1)
    setSearchPlaceholder("Search by Product Code")
    setTaxDetails(true)
  }, [clearStatus])


  useEffect(() => {

    const selectedLocation = txn.intTX_SEARCHBY_TOLOC == 1 ? (toLocationSelect == "" ? loccode : toLocationSelect) : loccode;

    if (txn.intTX_PROGRPLVL != null && txn.intTX_PROGRPLVL != 0) {
      let TX_PROGROUPS = txn.strTX_PROGRPCODES.split(',')
      let customString = '';

      for (let x = 0; x < TX_PROGROUPS.length; x++) {
        if (customString == '') {
          customString = "'" + TX_PROGROUPS[x].trim() + "'"
        } else {
          customString = customString + ",'" + TX_PROGROUPS[x].trim() + "'"
        }
      }

      if (txn.intTX_INCLUDEGROUPS == 1) {
        if (txn.intTX_SUPITEMS == 1) {
          customString = "AND M_TBLPROMASTER.PLU_GROUP" + txn.intTX_PROGRPLVL + "  IN (" + customString + ") AND SPLU_SMCODE = '" + supplierSelect + "' AND IPLU_LOCCODE = '" + selectedLocation + "'"
          if (txn.intTX_SKIP_PROSUP_LOCATION == 0) {
            customString = customString + " AND SPLU_LOCCODE = '" + selectedLocation + "'"
          }
        } else {
          customString = "AND M_TBLPROMASTER.PLU_GROUP" + txn.intTX_PROGRPLVL + "  IN (" + customString + ") AND IPLU_LOCCODE = '" + selectedLocation + "'"
        }
      } else {
        if (txn.intTX_SUPITEMS == 1) {
          customString = "AND M_TBLPROMASTER.PLU_GROUP" + txn.intTX_PROGRPLVL + " NOT IN (" + customString + ") AND SPLU_SMCODE = '" + supplierSelect + "' AND IPLU_LOCCODE = '" + selectedLocation + "'"

          if (txn.intTX_SKIP_PROSUP_LOCATION == 0) {
            customString = customString + " AND SPLU_LOCCODE = '" + selectedLocation + "'"
          }
        } else {
          customString = "AND M_TBLPROMASTER.PLU_GROUP" + txn.intTX_PROGRPLVL + " NOT IN (" + customString + ") AND IPLU_LOCCODE = '" + selectedLocation + "'"
        }
      }

      setProductSearchFilter(customString)
    } else {

      let customString = '';
      if (txn.intTX_SUPITEMS == 1) {
        if (isWMS == 1) {
          customString = " AND SPLU_SMCODE = '" + supplierSelect + "' AND IPLU_LOCCODE = '" + selectedLocation + "'"
        } else {
          customString = " AND SPLU_SMCODE = '" + supplierSelect + "' AND IPLU_LOCCODE = '" + selectedLocation + "'"

          if (txn.intTX_SKIP_PROSUP_LOCATION == 0) {
            customString = customString + " AND SPLU_LOCCODE = '" + selectedLocation + "'"
          }
        }

      } else {
        customString = " AND IPLU_LOCCODE = '" + selectedLocation + "'"
      }
      setProductSearchFilter(customString)
    }


  }, [txn, loccode, supplierSelect, toLocationSelect])



  useEffect(async () => {
    const ApiURL = window.Links.ApiURL;

    if (currentTxnType == type)
      return

    setCurrentTxnType(type)

    var requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      redirect: "follow",
    }

    fetch(`${ApiURL}txn/ui/${type}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setTxnUI(result.data)
        let prefix = 10
        let dat = result.data
        dat.map(r => {
          prefix = prefix + parseInt(r.strColWidth)
          if (r.strColTblName == "DET_PROCODE") {
            setProCode({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_STOCKCODE") {
            setStkCode({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_PRODESC") {
            setProDesc({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_UNIT") {
            setProUnit({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_SYSQTY") {
            setProSIH({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_VARQTY") {
            setProVAR({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_CS") {
            setProCS({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_EXPDATE") {
            setProExpDate({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_CPRICE") {
            setProCost({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_SPRICE") {
            setProSell({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_BALQTY") {
            setProBalQty({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_CASEQTY") {
            setProCaseQty({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_UNITQTY") {
            setProUnitQty({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_FUNITQTY") {
            setProFreeUnit({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_FCASEQTY") {
            setProFreeCase({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_DISCPER") {
            setProDiscPer({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_DISCAMT") {
            setProDiscAmt({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_AMOUNT") {
            setProAmt({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_REMCODE") {
            setProRemark({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "DET_ACOST") {
            setProWeightAvg({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          } else if (r.strColTblName == "Pack Price") {
            setProPackPrice({
              name: r.strColTblName,
              len: parseInt(r.strColLen),
              width: parseInt(r.strColWidth),
            })
          }
        })
        setPrefixWidth(prefix)
      }).catch(error => console.log("error", error))

  }, [type])


  const LabelFilter = priceMode => {

    if (priceMode == "C" || priceMode == "c") {

      if (parseFloat(procost.width) > 0) {
        return (
          <th
            style={{
              textAlign: "center",
              width: procost.width,
              WebkitTransform: "rotate(315deg)",
            }}
            title="Cost Price"
          >
            Cost
          </th>
        )
      } else {
        return (null)
      }

    } else if (priceMode == "S" || priceMode == "s") {
      if (parseFloat(prosell.width) > 0) {
        return (
          <th
            style={{
              textAlign: "center",
              width: prosell.width,
              WebkitTransform: "rotate(315deg)",
            }}
            title="Selling Price"
          >
            Sell
          </th>
        )
      } else {
        return (null)
      }

    } else if (priceMode == "A" || priceMode == "a") {
      if (parseFloat(proweightavg.width) > 0) {
        return (
          <th
            style={{
              textAlign: "center",
              width: proweightavg.width,
              WebkitTransform: "rotate(315deg)",
            }}
            title={txn.intTX_BOM == 1 ? "Production Cost" : "Weighted Average"}
          >
            {txn.intTX_BOM == 1 ? "Production Cost" : "Weight.Avg"}
          </th>
        )
      } else {
        return (null)
      }
    } else if (priceMode == "P" || priceMode == "p") {
      if (parseFloat(propackprice.width) > 0) {
        return (
          <th
            style={{
              textAlign: "center",
              width: propackprice.width,
              WebkitTransform: "rotate(315deg)",
            }}
            title="Pack/Case Price"
          >
            Pack Price
          </th>
        )
      } else {
        return (null)
      }

    }
  }


  /* Here is the explanation for the code below:
  1. We are getting the index of the object we want to change and assigning it to a variable.
  2. We are creating a new object with the same properties as the old one and updating the element we want to update.
  3. We are using the callback function for the SetDataRow function and assigning the new object to the index of the object we want to change. */

  const changeRowValueChanges = async (value, id, element) => {

    const updatedDataRow = DataRow.map(obj => {
      if (obj.id === id) {
        return { ...obj, [element]: value };
      }
      return obj;
    });

    SetDataRow(updatedDataRow);
    return updatedDataRow;

  };


  /* Here is the explanation for the code below:
  1. Find the index of the object that is being changed in the array.
  2. Create a new array with the new row that is being changed.
  3. Change the object in the array with the new row. */

  async function handleObjectChange(row, id) {

    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newDataRow = [...DataRow];
    newDataRow[objectIndex] = row;

    TotalLineAmtCalcualtion(newDataRow)
    return newDataRow;
  }

  async function calculateBomUnit() {

    if (txn.intTX_BOM == 1) {
      const finishProduct = DataRow.find((data) => data.strDET_PROCODE == proSelect);
      const bProduct = DataRow.find((data) => data.strDET_PROCODE == baseProduct);

      let convertRatio;

      if (bProduct) {

        let funitqty = DecimalValidation(bProduct.dcDET_FUNITQTY, 0, true, txnDecimalQty)

        if (parseFloat(funitqty) == 0 || parseFloat(bProduct.dcDET_VARQTY) == 0) {
          convertRatio = 0
        } else {
          convertRatio = parseFloat(funitqty) / parseFloat(bProduct.dcDET_VARQTY);
        }

      } else {

        let fcaseqty = DecimalValidation(finishProduct.dcDET_FCASEQTY, 0, true, txnDecimalQty)

        if (parseFloat(fcaseqty) == 0 || parseFloat(finishProduct.dcDET_VARQTY) == 0) {
          convertRatio = 0
        } else {
          convertRatio = parseFloat(fcaseqty) / parseFloat(finishProduct.dcDET_VARQTY);
        }

      }

      const filteredBOM = DataRow.filter((data) => data.strDET_PROCODE != proSelect);

      filteredBOM.map((item, index) => {

        let caseQty = parseFloat(item.dcDET_VARQTY) * parseFloat(convertRatio)

        caseQty = txn.intTX_FREEQTYMINUS == 1 ? Math.abs(caseQty) * -1 : caseQty

        caseQty = parseFloat(finishProduct.dcDET_FCASEQTY) > 0 ? caseQty : Math.abs(caseQty)

        item.dcDET_FUNITQTY = item.isDecimal == 1 ? Math.abs(parseFloat(parseFloat(item.dcDET_VARQTY) * parseFloat(convertRatio)).toFixed(txnDecimalQty)) : Math.abs(parseFloat(parseFloat(item.dcDET_VARQTY) * parseFloat(convertRatio)).toFixed(txnDecimalQty));
        item.dcDET_FCASEQTY = item.isDecimal == 1 ? parseFloat(caseQty).toFixed(txnDecimalQty) : parseFloat(caseQty).toFixed(txnDecimalQty);

      })

      filteredBOM.unshift(finishProduct); //add finish product to the top of the array

      SetDataRow(filteredBOM);
      TotalLineAmtCalcualtion(filteredBOM)

    }
  }


  async function handleScanDetailCode(proCode) {

    try {
      var barcodeElement = document.getElementById("ScanBarCode");

      const selectedLocation = txn.intTX_SEARCHBY_TOLOC == 1 ? (toLocationSelect == "" ? loccode : toLocationSelect) : loccode;

      SetLoadingAlert(true);
      SetLoadingAlerttitle("Scanning Product...");

      var response = await getProductDetailsCode(proCode, selectedLocation, txn.strTX_TYPE, supplierSelect, "")

      if (response.data.strStockCode != "") {
        var indexOfProduct = DataRow.findIndex((items) => items.strDET_STOCKCODE == response.data.strStockCode);
        //find page number

        if (indexOfProduct != -1) {
          var page = Math.ceil((indexOfProduct + 1) / pageSize);
          //set page number
          setPage(page);

          var unitElement = document.getElementById("DET_UNITQTY0");
          if (unitElement == null || unitElement == undefined) {
            setAlertColor("danger");
            setAlertMsg("Please Enable Unit Qty in Transaction UI!");
            setShow(true);
            setTimeout(() => {
              setShow(false);
            }, 5000);
            return
          }

          if (autoScan) { //if auto scan is active then add qty to the grid 
            var newDetail = DataRow.map((item, index) => {
              if (item.strDET_STOCKCODE == response.data.strStockCode) {

                const newQuantity = parseFloat(parseFloat(item.dcDET_UNITQTY) + parseFloat(1)).toFixed(item.isDecimal == 1 ? txnDecimalQty : 0);

                if (newQuantity > parseFloat(item.dcDET_BALQTY) && txn.intTX_REFQTYCHK == 1) {
                  if (!document.getElementById("voiceActive").checked) { //if voice is not muted
                    audioBalQtyErrorRef.current.play(); //play audio
                  }
                  setAlertColor("danger");
                  setAlertMsg("Can not enter more than balance quantity!");
                  setShow(true);
                  setTimeout(() => {
                    setShow(false);
                  }, 5000);

                } else {
                  if (!document.getElementById("voiceActive").checked) { //if voice is not muted
                    audioRef.current.play(); //play audio
                  }
                  item.dcDET_UNITQTY = newQuantity;
                }
              }
              return item;
            })

            TotalLineAmtCalcualtion(newDetail);
            SetDataRow(newDetail);
            barcodeElement.value = "";
            barcodeElement.focus();
          } else {

            var itemNo = (indexOfProduct) - (page - 1) * 10;
            barcodeElement.value = "";

            setTimeout(() => {
              var uniElement = document.getElementById("DET_UNITQTY" + itemNo);

              if (uniElement != null) {
                uniElement.focus();
              } else {
                setAlertColor("danger");
                setAlertMsg("Please Enable Unit Qty in Transaction UI!");
                setShow(true);
                setTimeout(() => {
                  setShow(false);
                }, 5000);
              }
            }, 100);

          }
        } else {

          if (!document.getElementById("voiceActive").checked) { //if voice is not muted
            audioProductErrorRef.current.play(); //play audio
          }

          setAlertColor("danger");
          setAlertMsg("Product Not Available in the Grid");
          setShow(true);
          setTimeout(() => {
            setShow(false);
          }, 5000);
        }

      } else {
        if (!document.getElementById("voiceActive").checked) { //if voice is not muted
          audioProductErrorRef.current.play(); //play audio
        }
        setAlertColor("danger");
        setAlertMsg("Product Not Found");
        setShow(true);
        setTimeout(() => {
          setShow(false);
        }, 5000);

      }



    } catch (error) {
      console.log(error)
    } finally {
      barcodeElement.value = "";
      SetLoadingAlert(false);
    }



  }


  async function DownloadExcelTemplate() {

    var element = document.createElement('a');
    element.setAttribute('href', TXN_QTY_Upload_Template);
    element.setAttribute('download', "QTY_Upload_Template.xlsx");
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);

  }




  const handleQtyUpdateUpload = (event) => {
    const file = event.target.files[0];

    if (RefDataRow.length == 0) return;

    // Basic validation for file type (optional)
    if (!file.type.match(/^(?:application\/vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet|application\/vnd\.ms-excel)$/)) {
      alert('Please select a valid Excel file (.xlsx or .xls)');
      return;
    }


    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const binaryString = event.target.result;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const data = XLSX.utils.sheet_to_json(worksheet)

        SetLoadingAlert(true);


        if (txn.intTX_VALIDATE_UPLOAD_QTY == 1) {

          SetLoadingAlerttitle("Uploading Excel File");
          const response = await spQtyUploadValidation(file, loccode)

          if (response.success) {
            SetLoadingAlerttitle("Validating QTY");
            const updatedDetailWithUnitQty = await UpdateUnitsWithExcel(DataRow, response.data, txn)

            TotalLineAmtCalcualtion(updatedDetailWithUnitQty);
            setAlertColor("success");
            setAlertMsg("QTY Updated Successfully!");

          } else {
            setAlertColor("danger");
            setAlertMsg(response.msg);
          }

        } else {
          SetLoadingAlerttitle("Validating QTY");
          const updatedDetailWithUnitQty = await UpdateUnitsWithExcel(DataRow, data, txn)

          TotalLineAmtCalcualtion(updatedDetailWithUnitQty);
          setAlertColor("success");
          setAlertMsg("QTY Updated Successfully!");

        }

      } catch (error) {
        console.error("Error reading file:", error);
        setAlertColor("danger");
        setAlertMsg("Error in Uploading File");
      } finally {
        SetLoadingAlert(false);
        setShow(true);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setTimeout(() => {
          setShow(false);
        }, 5000);
      }
    };
    reader.readAsArrayBuffer(file);

  };


  return (
    <React.Fragment>

      <Row>
        <DPLoadingAlert
          confirm_both={loadingAlert}
          title={loadingAlertTitle}
        />
      </Row>
      <Row className="mb-3">
        <audio ref={audioRef} src={audioFile} />
        <audio ref={audioProductErrorRef} src={audioFileProductError} />
        <audio ref={audioBalQtyErrorRef} src={audioFileBalQtyError} />
        <Col sm={12} md={4} className="mb-6-sm">
          <div className="input-group">
            <div className="input-group-prepend">
              <span style={{ height: '28px', marginLeft: '20px' }} className="input-group-text" id="basic-addon1"><i className="mdi mdi-magnify"></i></span>
            </div>

            <input id="SearchBar" type="text" className="form-control" value={searchString} placeholder={searchPlaceholder} aria-label="Username" aria-describedby="basic-addon1" style={{ height: '28px', width: '250px' }} onChange={e => {
              setSearchString(e.target.value)
              setPage(1)
            }} />
          </div>
        </Col>

        {txn.intTX_SCANACTIVE == 1 ?
          <Col sm={12} md={2} className="mb-6-sm">
            <DPTextBoxforgrid
              placeholder={"Scan Barcode..."}
              id={"ScanBarCode"}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleScanDetailCode(e.target.value)
                }
              }}
              disabled={DisableDet}
            />
          </Col> : null}

        {txn.intTX_AUTOORDER == 1 ? <Col sm={12} md={2} className="mb-6-sm">
          <Button
            disabled={DisableDet ? true : DataRow.some(x => x.strDET_PROCODE != "") ? true : processStat != "" ? true : false}
            size="sm"
            onClick={() => {
              setAlertConfirmOption(50)
              setAlertDescription("Are you sure you want to Auto Order?")
              setsweetAlertShow(true)
            }} className="btn btn-secondary">Auto Order</Button>

        </Col> : null}

        {txn.intTX_SCANACTIVE == 1 ? <Col sm={12} md={1} className="mb-6-sm">
          <Label>Mute Scan </Label>
        </Col> : null}

        {txn.intTX_SCANACTIVE == 1 ? <Col sm={12} md={1} className="mb-6-sm">
          <input id="voiceActive" disabled={DisableDet} style={{ width: '20px', height: '20px', cursor: 'pointer' }} type="checkbox" />
        </Col> : null}
        {txn.intTX_SCANBARCODE == 1 ? (
          <Col sm={12} md={2} className="mb-0-sm mt-1">
            <Row>
              <Col sm={5} style={{ textAlign: 'end' }}>Auto Scan</Col>
              <Col>
                <DPSwitch
                  rowClass={"mb-4-sm"}
                  onChange={() => {
                    SetAutoScan(!autoScan)
                  }}
                  checked={autoScan}
                  disabled={DisableDet}
                />
              </Col>
            </Row>
          </Col>
        ) : <Col sm={12} md={2} className="mb-0-sm"></Col>}

        <Col sm={12} md={2} className="mb-0-sm mt-1">
          <Button
            color="primary"
            size="sm"
            onClick={exportDataToExcel}
          >
            Export Data
          </Button>
        </Col>

        {txn.intTX_BOM == 1 ? (
          <Col sm={12} md={4} className="mb-0-sm mt-1">
            <Button
              disabled={DisableDet}
              color="primary"
              size="sm"
              title="Calculate BOM Finish Product Production Cost"
              onClick={async () => {
                await BomReCalculateFinishProAVGCost()
              }} >
              BOM Cost Calculation
            </Button>
          </Col>
        ) :
          txn.intTX_IS_CONSIGNMENT == 1 ? (
            <Col sm={12} md={2} className="mb-0-sm mt-1">
              <Button
                disabled={DisableDet ? true : generalFields.disableConsignment}
                color="primary"
                size="sm"
                title={txn.strTX_CONSIGNMENT_LABEL != "" ? txn.strTX_CONSIGNMENT_LABEL : "Consignment"}
                onClick={async () => {
                  await consignmentOnClick()
                }} >
                {txn.strTX_CONSIGNMENT_LABEL != "" ? txn.strTX_CONSIGNMENT_LABEL : "Consignment"}
              </Button>
            </Col>
          ) : null}
      </Row>

      <Row>
        <Col sm={12} md={6} className="d-flex mb-0-sm">
          {/* <RemarksDrawer
            isOpen={drawerOpen}
            onClose={toggleDrawer}
            data={DataRow.filter(row => row.strDET_PROCODE != '' && row.strDET_STOCKCODE != '')}
          />
          <Button
            color="primary"
            size="sm"
            onClick={toggleDrawer}
            className="me-2"
          >
            <i className="mdi mdi-format-list-bulleted me-1"></i>
            Add Prescription Remarks
          </Button> */}
        </Col>
        {txn.intTX_BOM == 0 && txn.intTX_PRODUCTION == 0 && txn.intTX_VERIFICATION == 0 && txn.strTX_REFTYPES != "" && RefCode != "" && RefDataRow.length > 0 ?
          <Col sm={12} md={6} className="d-flex justify-content-end mb-0-sm">
            <label
              onClick={async () => {
                await DownloadExcelTemplate()
              }}
              className="btn btn-primary btn-sm mx-2"
              title="Download QTY Update Template"
            >
              QTY Update Template
              <i className="fas fa-arrow-down ml-1 mx-2"></i>
            </label>

            <input
              type="file"
              accept=".xlsx, .xlsm, .xlsb"
              disabled={DisableDet}
              className="custom-file-input"
              id="qtyUpdateUploadInput"
              onChange={handleQtyUpdateUpload}
              hidden
              ref={fileInputRef}

            />
            <label
              htmlFor="qtyUpdateUploadInput"
              className="btn btn-primary btn-sm"
              title="Upload QTY Template"
            >
              QTY Update
              <i className="fas fa-arrow-up ml-1 mx-2"></i>
            </label>
          </Col> : null}
      </Row>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <div style={{ overflow: "auto", maxHeight: "400px", minHeight: "150px" }}>
            <table
              style={{ fontSize: "11px", width: prefixwidth }}
              id={"TransactionDet"}
            >
              {/*className="table-light"*/}
              <thead className="common-bg"
                style={{
                  position: "sticky",
                  top: "0",
                  zIndex: "50",
                  //backgroundColor: "#2a3042",
                }}
              >
                <tr>
                  <th ></th>
                  <th></th>
                  {txn.intTX_BOM == 0 ? (<th></th>) : null}
                  {txn.intTX_STOCKCODE == 1 ? (<th></th>) : null}
                  <th></th>
                  <th></th>
                  {txn.intTX_SHOWCS != 0 ? (<th></th>) : null}
                  {txn.intTX_SHOWSIH != 0 ? (<th></th>) : null}
                  {txn.intTX_SHOWSIH != 0 ? (<th></th>) : null}
                  {txn.intTX_SHOWVAR == 1 || txn.intTX_BOM == 1 ? (<th></th>) : null}
                  {txn.intTX_SHOWGP == 1 ? (<th></th>) : null}
                  {txn.intTX_SHOWGP == 1 ? (<th></th>) : null}
                  {txn.intTX_EXPCHKSIH == 1 ? (<th></th>) : null}
                  {txn.strTX_SHOWPRICE == txn.strTX_PRICEMODE ? <th></th> : txn.strTX_SHOWPRICE == "C" ? <th></th> : txn.strTX_PRICEMODE != "" ? <th></th> : null}
                  {txn.strTX_SHOWPRICE == txn.strTX_PRICEMODE ? null : txn.strTX_SHOWPRICE == "S" ? <th></th> : txn.strTX_PRICEMODE != "" && txn.strTX_SHOWPRICE != "" ? <th></th> : null}
                  {txn.intTX_SHOW_BALQTY == 1 ? (<th></th>) : null}
                  {txn.intTX_SHOW_FBALQTY == 1 ? (<th></th>) : null}
                  {txn.intTX_CASEQTY != 0 ? (<th></th>) : null}
                  {txn.intTX_UNITQTY != 0 ? (<th></th>) : null}
                  {txn.intTX_FREEUNITQTY != 0 ? (<th></th>) : null}
                  {txn.intTX_FREECASEQTY != 0 ? (<th></th>) : null}
                  {txn.intTX_LINEDISCPER != 0 ? (<th></th>) : null}
                  {txn.intTX_HIDEPRICES == 0 ? (<th colSpan={3}>
                    {txn.intTX_CHKREFAMT == 1 ? FormatNumberTODecimal(txRefAmount) - FormatNumberTODecimal(txNetAmount) != 0 ? "Difference : " + parseFloat(FormatNumberTODecimal(txRefAmount) - FormatNumberTODecimal(txNetAmount)).toFixed(txnDecimalAmt) : null : null}
                  </th>) : null}
                  {txn.intTX_LINEREMARKS == 1 ? (<th></th>) : null}
                  <th></th>
                  <th></th>
                  {txn.intTX_SHOWFILLRATE == 1 ? <th></th> : null}
                </tr>

                <tr style={{ height: '70px' }}>
                  <th style={{ width: "20px" }}>#</th>
                  <th style={{ textAlign: "left", width: procode.width, cursor: 'pointer' }} onClick={() => {
                    setElement("strDET_PROCODE")
                    setSearchPlaceholder("Search By Product Code")
                    setPage(1)
                    setSearchString("")
                  }}>
                    Code
                  </th>
                  {txn.intTX_BOM == 0 ? (
                    <th></th>
                  ) : null}
                  {txn.intTX_STOCKCODE == 1 ? (
                    <th style={{ textAlign: "left", width: stkcode.width, cursor: 'pointer' }} onClick={() => {
                      setElement("strDET_STOCKCODE")
                      setSearchPlaceholder("Search By Stock Code")
                      setPage(1)
                      setSearchString("")
                    }}>
                      Stock Code{" "}
                    </th>
                  ) : null}
                  <th style={{ textAlign: "left", width: prodesc.width, cursor: 'pointer' }} onClick={() => {
                    setElement("strDET_PRODESC")
                    setSearchPlaceholder("Search By Product Description")
                    setPage(1)
                    setSearchString("")
                  }}>
                    Description{" "}
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      width: prounit.width,
                      WebkitTransform: "rotate(315deg)",
                    }}
                    title="Unit of Measure"
                  >
                    Unit
                  </th>
                  {txn.intTX_SHOWCS != 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: procs.width,
                        WebkitTransform: "rotate(315deg)",
                        height: "65px",
                      }}
                      title="Pack/Case Size"
                    >
                      Case/Pack Size
                    </th>
                  ) : null}
                  {txn.intTX_SHOWSIH != 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: procs.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title="Stock in hand"
                    >
                      SOH
                    </th>
                  ) : null}
                  {txn.intTX_SHOWSIH != 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title=""
                    >
                    </th>
                  ) : null}
                  {txn.intTX_SHOWVAR == 1 || txn.intTX_BOM == 1 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: procs.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title={txn.intTX_SHOWVAR == 1 ? "Variance" : "BOM Qty"}
                    >
                      {txn.intTX_SHOWVAR == 1 ? "Variance" : "BOM Qty"}
                    </th>
                  ) : null}
                  {txn.intTX_SHOWGP == 1 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: procs.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title={"GP"}>
                      GP Fix
                    </th>
                  ) : null}
                  {txn.intTX_SHOWGP == 1 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: procs.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title={"GP"}>
                      GP Current
                    </th>
                  ) : null}
                  {txn.intTX_EXPCHKSIH == 1 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: procs.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                    >
                      Expiry Date
                    </th>
                  ) : null}

                  {String(txn.strTX_SHOWPRICE).toLowerCase() == 'c' ? LabelFilter(txn.strTX_SHOWPRICE) : String(txn.strTX_PRICEMODE).toLowerCase() == 'c' ? LabelFilter(txn.strTX_PRICEMODE) : null}
                  {String(txn.strTX_SHOWPRICE).toLowerCase() == 's' ? LabelFilter(txn.strTX_SHOWPRICE) : String(txn.strTX_PRICEMODE).toLowerCase() == 's' ? LabelFilter(txn.strTX_PRICEMODE) : null}
                  {String(txn.strTX_SHOWPRICE).toLowerCase() == 'a' ? LabelFilter(txn.strTX_SHOWPRICE) : String(txn.strTX_PRICEMODE).toLowerCase() == 'a' ? LabelFilter(txn.strTX_PRICEMODE) : null}
                  {String(txn.strTX_SHOWPRICE).toLowerCase() == 'p' ? LabelFilter(txn.strTX_SHOWPRICE) : String(txn.strTX_PRICEMODE).toLowerCase() == 'p' ? LabelFilter(txn.strTX_PRICEMODE) : null}

                  {txn.intTX_SHOW_BALQTY == 1 ? (
                    <th
                      style={{
                        textAlign: "center",
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title="Balance Quantity"
                    >
                      Bal. Qty
                    </th>
                  ) : null}
                  {txn.intTX_SHOW_FBALQTY == 1 ? (
                    <th
                      style={{
                        textAlign: "center",
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title="Free Balance Quantity"
                    >
                      Free Bal. Qty
                    </th>
                  ) : null}
                  {txn.intTX_CASEQTY != 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: procaseqty.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title="Pack/Case Quantity"
                    >
                      Case&nbsp;Qty
                    </th>
                  ) : null}
                  {txn.intTX_UNITQTY != 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: prouniteqty.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      // title={
                      //   txn.strTX_TYPE == "SVN" || txn.intTX_BOM == 1 || txn.strTX_TYPE == "PRE" || txn.strTX_TYPE == "PRO"
                      //     ? "Add Quantity"
                      //     : "Unit Quantity"
                      // }
                      title={
                        txn.strTX_UNITQTY_CAPTION != ""
                          ? txn.strTX_UNITQTY_CAPTION
                          : "Unit Quantity"
                      }
                    >
                      {/* {txn.strTX_TYPE == "SVN" || txn.intTX_BOM == 1 || txn.strTX_TYPE == "PRE" || txn.strTX_TYPE == "PRO" ? "Add Qty" : "Unit Qty"} */}
                      {txn.strTX_UNITQTY_CAPTION != "" ? txn.strTX_UNITQTY_CAPTION : "Unit Qty"}
                    </th>
                  ) : null}
                  {txn.intTX_FREEUNITQTY != 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: profreeunit.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      // title={
                      //   txn.strTX_TYPE == "SVN" || txn.intTX_BOM == 1 || txn.strTX_TYPE == "PRE" || txn.strTX_TYPE == "PRO"
                      //     ? "Deduct Quantity"
                      //     : "Free Unit Quantity"
                      // }
                      title={
                        txn.strTX_FREEUNITQTY_CAPTION != ""
                          ? txn.strTX_FREEUNITQTY_CAPTION
                          : txn.intTX_BOM == 1 ? "Formula\xa0QTY" : "Free Unit Quantity"
                      }
                    >
                      {/* {txn.strTX_TYPE == "SVN" || txn.intTX_BOM == 1 || txn.strTX_TYPE == "PRE" || txn.strTX_TYPE == "PRO"
                        ? "Deduct\xa0Qty"
                        : "Free\xa0Unit"} */}
                      {txn.strTX_FREEUNITQTY_CAPTION != ""
                        ? txn.strTX_FREEUNITQTY_CAPTION
                        : txn.intTX_BOM == 1 ? "Formula\xa0QTY" : "Free\xa0Unit"}
                    </th>
                  ) : null}
                  {txn.intTX_FREECASEQTY != 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: profreeunit.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title={
                        txn.intTX_BOM == 1 ?
                          "Actual\xa0QTY" :
                          "Free\xa0Case"
                      }
                    >
                      {txn.intTX_BOM == 1 ? "Actual\xa0QTY" : "Free\xa0Case"}
                    </th>
                  ) : null}
                  {txn.intTX_LINEDISCPER != 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: prodiscper.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title="Discount Percentage"
                    >
                      Disc %{" "}
                    </th>
                  ) : null}
                  {txn.intTX_LINEDISCAMT != 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: prodiscamt.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                      title="Discount Amount"
                    >
                      Disc.&nbsp;Amt.
                    </th>
                  ) : null}
                  {txn.intTX_HIDEPRICES == 0 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: proamt.width,
                        WebkitTransform: "rotate(315deg)",
                      }}
                    >
                      Amount
                    </th>
                  ) : null}
                  {txn.intTX_LINEREMARKS == 1 ? (
                    <th
                      style={{
                        textAlign: "center",
                        width: proremark.width,
                        // WebkitTransform: "rotate(315deg)",
                        // zIndex: -1
                      }}
                      title="Pre Define Remarks"
                    >
                      Remark
                    </th>
                  ) : null}
                  <th></th>
                  <th></th>
                  {txn.intTX_SHOWFILLRATE == 1 ? <th
                    style={{
                      textAlign: "center",
                      width: '60px',
                      WebkitTransform: "rotate(315deg)",
                      zIndex: -1
                    }}
                    title="Fill Rate"
                  >
                    Fill Rate
                  </th> : null}
                </tr>
              </thead>
              <tbody style={{ fontSize: "10px" }}>
                {(currentDetailRows || [{ id: 1 }]).map((formRow, key) => (
                  <TableRow
                    FormRow={formRow}
                    Key={key}
                    RemoveRow={RemoveRow}
                    Disabled={blDiasableGrid}
                    BookChange={BookChange}
                    SupplierCode={SupplierCode}
                    txnUI={txnUI}
                    procode={procode}
                    stkcode={stkcode}
                    prodesc={prodesc}
                    prounit={prounit}
                    proexpdate={proexpdate}
                    procost={procost}
                    prosell={prosell}
                    proweightavg={proweightavg}
                    propackprice={propackprice}
                    probalqty={probalqty}
                    procs={procs}
                    prosih={prosih}
                    provar={provar}
                    procaseqty={procaseqty}
                    prouniteqty={prouniteqty}
                    profreeunit={profreeunit}
                    profreecase={profreecase}
                    prodiscper={prodiscper}
                    prodiscamt={prodiscamt}
                    proamt={proamt}
                    proremark={proremark}
                    txn={txn}
                    taxTable={taxTable}
                    SetTaxTable={SetTaxtTable}
                    SetGrossTotals={SetGrossTotaltx}
                    SetTxNetAmount={SetTxNetAmount}
                    GrossTotal={GrossTotal}
                    SetLineDisc={SetLineDisc}
                    lineDisc={lineDisc}
                    TaxDetails={TaxDetails}
                    RefDataRow={RefDataRow}
                    supplierSelect={supplierSelect}
                    loccode={loccode}
                    DisableDet={DisableDet}
                    AutoScan={autoScan}
                    AddRow={AddRow}
                    TxnTotalCal={TxnTotalCal}
                    detailReasonTypes={detailReasonTypes}
                    menuCode={menuCode}
                    setDataForRecovery={setDataForRecovery}
                    menuName={menuName}
                    Reason={Reason}
                    setReason={setReason}
                    setPermissionAlertShow={setPermissionAlertShow}
                    setAlertConfirmOption={setAlertConfirmOption}
                    AlertConfirmOption={AlertConfirmOption}
                    AllPara={AllPara}
                    setTaxProductCodes={setTaxProductCodes}
                    taxProductCodes={taxProductCodes}
                    SetDataRow={SetDataRow}
                    SetTaxLineRemarks={SetTaxLineRemarks}
                    TaxLineRemarks={TaxLineRemarks}
                    setAlertColor={setAlertColor}
                    setAlertMsg={setAlertMsg}
                    setShow={setShow}
                    DataRow={DataRow}
                    productSearchFilter={productSearchFilter}
                    changeRowValueChanges={changeRowValueChanges}
                    handleObjectChange={handleObjectChange}
                    priceModeSelect={priceModeSelect}
                    setPage={setPage}
                    indexOfFirstPost={indexOfFirstPost}
                    baseProduct={baseProduct}
                    proSelect={proSelect}
                    calculateBomUnit={calculateBomUnit}
                    txnDecimalAmt={txnDecimalAmt}
                    txnDecimalQty={txnDecimalQty}
                    toLocationSelect={toLocationSelect}
                    setReasonForDetails={setReasonForDetails}
                    reasonForDetails={reasonForDetails}
                    processStat={processStat}
                    RefStockFreeze={RefStockFreeze}
                    RefCode={RefCode}
                    txnTaxTypes={txnTaxTypes}
                    newTaxTable={newTaxTable}
                    setNewTaxTable={setNewTaxTable}
                    customerSelect={customerSelect}
                    currentDetailRows={currentDetailRows}
                    loadingAlertTitle={loadingAlertTitle}
                    SetLoadingAlerttitle={SetLoadingAlerttitle}
                    loadingAlert={loadingAlert}
                    SetLoadingAlert={SetLoadingAlert}
                    TotalLineAmtCalcualtion={TotalLineAmtCalcualtion}
                    pageSize={pageSize}
                    validToDate={validToDate}
                    validFromDate={validFromDate}
                    generalFields={generalFields}
                  />
                ))}
              </tbody>
              {txn.intTX_BOM == 1 ? (
                <tfoot>
                  <tr>
                    <th ></th>
                    <th></th>
                    {txn.intTX_BOM == 0 ? (<th></th>) : null}
                    {txn.intTX_STOCKCODE == 1 ? (<th></th>) : null}
                    <th></th>
                    <th></th>
                    {txn.intTX_SHOWCS != 0 ? (<th></th>) : null}
                    {txn.intTX_SHOWSIH != 0 ? (<th></th>) : null}
                    {txn.intTX_SHOWSIH != 0 ? (<th></th>) : null}
                    {txn.intTX_SHOWVAR == 1 || txn.intTX_BOM == 1 ? (
                      <th>
                        <DPTextBoxforgrid
                          rowClass="mb-12-sm"
                          labelText=""
                          textType="text"
                          textAlign={"right"}
                          value={parseFloat((DataRow.reduce((a, b) => a + ((b.strDET_PROCODE == proSelect) ? 0 : parseFloat(b.dcDET_VARQTY)), 0))).toFixed(txnDecimalQty)}
                          disabled={true}
                        />
                      </th>
                    ) : null}
                    {txn.intTX_SHOWGP == 1 ? (<th></th>) : null}
                    {txn.intTX_SHOWGP == 1 ? (<th></th>) : null}
                    {txn.intTX_EXPCHKSIH == 1 ? (<th></th>) : null}
                    {txn.strTX_SHOWPRICE == txn.strTX_PRICEMODE ? <th></th> : txn.strTX_SHOWPRICE == "C" ? <th></th> : txn.strTX_PRICEMODE != "" ? <th></th> : null}
                    {txn.strTX_SHOWPRICE == txn.strTX_PRICEMODE ? null : txn.strTX_SHOWPRICE == "S" ? <th></th> : txn.strTX_PRICEMODE != "" && txn.strTX_SHOWPRICE != "" ? <th></th> : null}
                    {txn.intTX_SHOW_BALQTY == 1 ? (<th></th>) : null}
                    {txn.intTX_SHOW_FBALQTY == 1 ? (<th></th>) : null}
                    {txn.intTX_CASEQTY != 0 ? (<th></th>) : null}
                    {txn.intTX_UNITQTY != 0 ? (<th></th>) : null}
                    {txn.intTX_FREEUNITQTY != 0 ? (
                      <th>
                        <DPTextBoxforgrid
                          rowClass="mb-12-sm"
                          labelText=""
                          textType="text"
                          textAlign={"right"}
                          value={Math.abs(parseFloat((DataRow.reduce((a, b) => a + ((b.strDET_PROCODE == proSelect) ? 0 : parseFloat(b.dcDET_FUNITQTY)), 0))).toFixed(txnDecimalQty))}
                          disabled={true}
                        /></th>
                    ) : null}
                    {txn.intTX_FREECASEQTY != 0 ? (
                      <th>
                        <DPTextBoxforgrid
                          rowClass="mb-12-sm"
                          labelText=""
                          textType="text"
                          textAlign={"right"}
                          value={Math.abs(parseFloat((DataRow.reduce((a, b) => a + ((b.strDET_PROCODE == proSelect) ? 0 : parseFloat(b.dcDET_FCASEQTY)), 0))).toFixed(txnDecimalQty))}
                          disabled={true}
                        />
                      </th>
                    ) : null}
                    {txn.intTX_LINEDISCPER != 0 ? (<th></th>) : null}
                    {txn.intTX_LINEDISCAMT != 0 ? (<th></th>) : null}
                    {txn.intTX_HIDEPRICES == 0 ? (<th></th>) : null}
                    {txn.intTX_LINEREMARKS == 1 ? (<th></th>) : null}
                    <th></th>
                    <th></th>
                    {txn.intTX_SHOWFILLRATE == 1 ? <th></th> : null}
                  </tr>
                </tfoot>
              ) : txn.intTX_SHOWCOUNT == 1 ? <tfoot>
                <tr>
                  <th></th>
                  <th>Product Count</th>
                  {<th>{DataRow.filter(item => item.strDET_PROCODE != "" && item.strDET_PRODESC != "").length}</th>}
                  {txn.intTX_STOCKCODE == 1 ? (<th></th>) : null}
                  <th></th>
                  <th></th>
                  {txn.intTX_SHOWCS != 0 ? (<th></th>) : null}
                  {txn.intTX_SHOWSIH != 0 ? (<th></th>) : null}
                  {txn.intTX_SHOWSIH != 0 ? (<th></th>) : null}
                  {txn.intTX_SHOWVAR == 1 || txn.intTX_BOM == 1 ? (<th></th>) : null}
                  {txn.intTX_SHOWGP == 1 ? (<th></th>) : null}
                  {txn.intTX_SHOWGP == 1 ? (<th></th>) : null}
                  {txn.intTX_EXPCHKSIH == 1 ? (<th></th>) : null}
                  {txn.strTX_SHOWPRICE == txn.strTX_PRICEMODE ? <th></th> : txn.strTX_SHOWPRICE == "C" ? <th></th> : txn.strTX_PRICEMODE != "" ? <th></th> : null}
                  {txn.strTX_SHOWPRICE == txn.strTX_PRICEMODE ? null : txn.strTX_SHOWPRICE == "S" ? <th></th> : txn.strTX_PRICEMODE != "" && txn.strTX_SHOWPRICE != "" ? <th></th> : null}
                  {txn.intTX_SHOW_BALQTY == 1 ? (
                    <th></th>
                  ) : null}
                  {txn.intTX_SHOW_FBALQTY == 1 ? (
                    <th></th>
                  ) : null}
                  {txn.intTX_CASEQTY != 0 ? (
                    <th>
                      <DPTextBoxforgrid
                        rowClass="mb-12-sm"
                        labelText=""
                        textType="text"
                        textAlign={"right"}
                        value={Math.abs(parseFloat(DataRow.reduce((a, b) => a + (parseFloat(b.dcDET_CASEQTY)), 0)).toFixed(txnDecimalQty))}
                        disabled={true}
                      />
                    </th>
                  ) : null}
                  {txn.intTX_UNITQTY != 0 ? (
                    <th>
                      <DPTextBoxforgrid
                        rowClass="mb-12-sm"
                        labelText=""
                        textType="text"
                        textAlign={"right"}
                        value={Math.abs(parseFloat(DataRow.reduce((a, b) => a + (parseFloat(b.dcDET_UNITQTY)), 0)).toFixed(txnDecimalQty))}
                        disabled={true}
                      />
                    </th>
                  ) : null}
                  {txn.intTX_FREEUNITQTY != 0 ? (<th></th>) : null}
                  {txn.intTX_FREECASEQTY != 0 ? (<th></th>) : null}
                  {txn.intTX_LINEDISCPER != 0 ? (<th></th>) : null}
                  {txn.intTX_LINEDISCAMT != 0 ? (<th></th>) : null}
                  {txn.intTX_HIDEPRICES == 0 ? (<th></th>) : null}
                  {txn.intTX_LINEREMARKS == 1 ? (<th></th>) : null}
                  <th></th>
                  <th></th>
                  {txn.intTX_SHOWFILLRATE == 1 ? <th></th> : null}
                </tr>
              </tfoot> : null
              }
            </table>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={1} className="mb-12-sm" style={{ marginLeft: '13px' }}>
          {txn.intTX_BOM == 0 ? (
            <Button
              onClick={() => {
                AddRow()
              }}
              disabled={txn.intTX_ITEMCHANGE == 1 ? true : DisableDet}
              color="success"
              className="m-2"
              id="DETADDNEW"
              size="sm"
            >
              <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
            </Button>
          ) : null}
        </Col>
        <Col sm={12} md={2} className="mb-12-sm">
          <DPDropDown
            colWidth={7}
            colClass="col-md-6"
            rowClass="mb-12-sm mt-2"
            labelText="Row Count"
            selectedGroup={pageSize}
            onChange={(e) => {
              setPageSize(e["value"])
            }}
            optionGroup={[{
              label: "10",
              value: 10,
            }, {
              label: "25",
              value: 25,
            }, {
              label: "50",
              value: 50,
            }, {
              label: "100",
              value: 100,
            }
            ]}
          />
        </Col>

        <Col sm={12} md={2} className="mb-12-sm">
          {taxTable.length > 0 && txn.inTX_TAX == 1 ? (<Button
            onClick={() => {
              setTaxDetails(!taxDetails)
            }}
            disabled={false}
            style={{ border: 0 }}
            color="secondary"
            className="m-2 "
            id="DETADDNEW"
            size="sm"
          >
            {taxDetails ? "Show Tax Summary" : "Show Tax Details"}
          </Button>) : null}
        </Col>

        <Col sm={12} md={6} className="mb-12-sm mt-2">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(SearchFilteredDataTable.length / pageSize)}
            pageRangeDisplayed={2}
            onPageChange={handlePageClick}
            forcePage={page - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-end pagination-sm'}

          />
        </Col>

      </Row>
      <Row>

        {taxTable.length > 0 && txn.inTX_TAX == 1 > 0 && taxDetails ? (
          <Col sm={12} md={7} className="mb-12-sm">
            <table className="table table-bordered  table-sm rounded" style={{ fontSize: "11px", maxHeight: "200px", marginLeft: '20px', marginRight: '10px' }} id={"TxnDet"}>
              <thead className="table-light">
                <tr>
                  <th style={{ textAlign: "left" }}>Pro. Code</th>
                  <th style={{ textAlign: "left" }}>Pro. Description </th>
                  <th style={{ textAlign: "left" }}>Tax</th>
                  <th style={{ textAlign: "right" }}>Gross Amount</th>
                  <th style={{ textAlign: "right" }}>Tax Rate (%)</th>
                  <th style={{ textAlign: "right" }}>Inclusive/Exclusive</th>
                  <th style={{ textAlign: "right" }}>Tax Amount</th>
                </tr>
              </thead>
              <tbody>
                {(currentTax || [{ id: 1 }]).map((formRow, key) => (
                  <TableTaxRow FormRow={formRow} Key={key} txnDecimalAmt={txnDecimalAmt} />
                ))}
              </tbody>
            </table>
          </Col>)
          : <Col sm={12} md={7} className="mb-12-sm"></Col>}

        {taxTable.length > 0 && txn.inTX_TAX == 1 > 0 && !taxDetails ? (
          <Col sm={12} md={7} className="mb-12-sm">
            <table className="table table-bordered  table-sm rounded" style={{ fontSize: "11px", maxHeight: "200px", marginLeft: '20px', marginRight: '10px' }} id={"TxnDet"}>
              <thead className="table-light">
                <tr>
                  <th style={{ textAlign: "left" }}>Tax</th>
                  <th style={{ textAlign: "right" }}>Tax Rate (%)</th>
                  <th style={{ textAlign: "right" }}>Inclusive/Exclusive</th>
                  <th style={{ textAlign: "right" }}>Tax Amount</th>
                </tr>
              </thead>
              <tbody>
                <TableTaxSummary TaxTable={taxTable} txnDecimalAmt={txnDecimalAmt} />
              </tbody>
            </table>
          </Col>)
          : null}

        <Col sm={12} md={5} className="mb-12-sm ml-1">
          <Row style={{ display: "none" }}>
            <Col sm={4}>
              <Label htmlFor="example-text-input">Line Discounts</Label>
            </Col>
            <Col sm={4} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                disabled={true}
                textAlign="right"
                value={lineDisc.toLocaleString(undefined, {
                  maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt,
                  minimumFractionDigits: 2,
                })}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          {txn.intTX_HIDEPRICES == 0 ? (
            <Row className="mb-1" style={{ marginLeft: '20px' }}>
              <Col sm={4}>
                <Label htmlFor="example-text-input">Gross Amount</Label>
              </Col>
              <Col sm={4} style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  disabled={true}
                  textAlign="right"
                  // value={GrossTotal.toLocaleString(undefined, { maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt, minimumFractionDigits: 2, })}
                  value={parseFloat(GrossTotal).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: txnDecimalAmt,
                  })}
                ></DPTextBoxforgrid>
              </Col>
            </Row>
          ) : null}
          {txn.intTX_NETDISCPER == 1 ? (
            <Row className="mb-1" style={{ marginLeft: '20px' }}>
              <Col sm={4}>
                <Label htmlFor="example-text-input">Discount %</Label>
                <Label htmlFor="example-text-input">
                  {"[" + txDiscountAmt.toLocaleString('en-US', { maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt, minimumFractionDigits: 2, }) + "]"}
                </Label>
              </Col>
              <Col sm={4} style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  textAlign="right"
                  disabled={DisableDet}
                  value={txDiscount}
                  onChange={SetTxDiscount}
                  onBlur={TxnTotalCal}
                  onKeyPress={TxnTotalCal}
                ></DPTextBoxforgrid>
              </Col>
            </Row>
          ) : null}
          {txn.intTX_ADDTIONS == 1 ? (
            <Row className="mb-1" style={{ marginLeft: '20px' }}>
              <Col sm={4}>
                <Label htmlFor="example-text-input">Additions</Label>
              </Col>
              <Col sm={4} style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  textAlign="right"
                  disabled={DisableDet}
                  value={txAddition.toLocaleString(undefined, { maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt, minimumFractionDigits: 2, })}
                  onChange={SetTxAddition}
                  onBlur={TxnTotalCal}
                  onKeyPress={TxnTotalCal}
                ></DPTextBoxforgrid>
              </Col>
            </Row>
          ) : null}
          {txn.intTX_DEDUCTIONS == 1 ? (
            <Row className="mb-1" style={{ marginLeft: '20px' }}>
              <Col sm={4}>
                <Label htmlFor="example-text-input">Deductions</Label>
              </Col>
              <Col sm={4} style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  textAlign="right"
                  disabled={DisableDet ? true : isWMS && parseFloat(supplierContribution) > 0 ? true : false}
                  value={txDeduction.toLocaleString(undefined, { maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt, minimumFractionDigits: 2, })}
                  onChange={SetTxDeduction}
                  onBlur={TxnTotalCal}
                  onKeyPress={TxnTotalCal}
                ></DPTextBoxforgrid>
              </Col>
            </Row>
          ) : null}
          {txn.inTX_TAX == 1 ? (
            <Row className="mb-1" style={{ marginLeft: '20px' }}>
              <Col sm={4}>
                <Label htmlFor="example-text-input">Tax [Inclusive]</Label>
              </Col>
              <Col sm={4} style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  disabled={true}
                  textAlign="right"
                  value={parseFloat(txTaxInc).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: txnDecimalAmt,
                  })}
                ></DPTextBoxforgrid>
              </Col>
            </Row>
          ) : null}

          {txn.inTX_TAX == 1 ? (
            <Row className="mb-1" style={{ marginLeft: '20px' }}>
              <Col sm={4}>
                <Label htmlFor="example-text-input">Tax [Exclusive]</Label>
              </Col>
              <Col sm={4} style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  disabled={true}
                  textAlign="right"
                  value={parseFloat(txTaxExc).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: txnDecimalAmt,
                  })}
                ></DPTextBoxforgrid>
              </Col>
            </Row>
          ) : null}

          {txn.intTX_HIDEPRICES == 0 ? (
            <Row className="mb-1" style={{ marginLeft: '20px' }}>
              <Col sm={4}>
                <Label htmlFor="example-text-input">Net Amount</Label>
              </Col>
              <Col sm={4} style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  disabled={true}
                  textAlign="right"
                  value={parseFloat(txNetAmount).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: txnDecimalAmt,
                  })}
                ></DPTextBoxforgrid>
              </Col>
            </Row>
          ) : null}
          {txn.intTX_BOM == 1 ? (
            <Row className="mb-1" style={{ marginLeft: '20px' }}>
              <Col sm={4}>
                <Label htmlFor="example-text-input">From Value</Label>
              </Col>
              <Col sm={4} style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  textType="text"
                  maxLength="8"
                  disabled={true}
                  textAlign="right"
                  // value={parseFloat(bomFromValue).toFixed(txnDecimalAmt)}
                  value={parseFloat(bomFromValue).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: txnDecimalAmt,
                  })}
                ></DPTextBoxforgrid>
              </Col>
            </Row>
          ) : null}
          {txn.intTX_BOM == 1 ? (
            <Row className="mb-1" style={{ marginLeft: '20px' }}>
              <Col sm={4}>
                <Label htmlFor="example-text-input">To Value</Label>
              </Col>
              <Col sm={4} style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  textType="text"
                  maxLength="8"
                  disabled={true}
                  textAlign="right"
                  // value={parseFloat(bomToValue).toFixed(txnDecimalAmt)}
                  value={parseFloat(bomToValue).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: txnDecimalAmt,
                  })}
                ></DPTextBoxforgrid>
              </Col>
            </Row>
          ) : null}
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          {txn.intTX_SAVEINVOICE == 1 ? (
            <Payment
              menuCode={menuCode}
              DataRow={PayDataRow}
              AddPayRow={AddPayRow}
              Disabled={DisableDet}
              PaidAmt={PaidAmt}
              DueAmt={DueAmt}
              TotalPayCalculation={TotalPayCalculation}
              SetPayDataRow={SetPayDataRow}
            />
          ) : null}
        </Col>
      </Row>
    </React.Fragment >
  )
}
export default TransactionDET

//* Single Row for TXN Details table */
const TableRow = ({
  FormRow,
  Key,
  RemoveRow,
  Disabled,
  procode,
  stkcode,
  prodesc,
  prounit,
  proexpdate,
  procost,
  prosell,
  proweightavg,
  propackprice,
  probalqty,
  procs,
  prosih,
  provar,
  procaseqty,
  prouniteqty,
  profreeunit,
  profreecase,
  prodiscper,
  prodiscamt,
  proamt,
  proremark,
  txn,
  taxTable,
  SetTaxTable,
  RefDataRow,
  supplierSelect,
  loccode,
  DisableDet,
  AutoScan,
  AddRow,
  TxnTotalCal,
  detailReasonTypes,
  menuCode,
  menuName,
  setPermissionAlertShow,
  setAlertConfirmOption,
  AlertConfirmOption,
  AllPara,
  SetTaxLineRemarks,
  TaxLineRemarks,
  setAlertColor,
  setAlertMsg,
  setShow,
  DataRow,
  productSearchFilter,
  changeRowValueChanges,
  handleObjectChange,
  priceModeSelect,
  setPage,
  indexOfFirstPost,
  baseProduct,
  proSelect,
  calculateBomUnit,
  txnDecimalAmt,
  txnDecimalQty,
  toLocationSelect,
  setReasonForDetails,
  reasonForDetails,
  RefCode,
  txnTaxTypes,
  customerSelect,
  currentDetailRows,
  loadingAlertTitle,
  SetLoadingAlerttitle,
  loadingAlert,
  SetLoadingAlert,
  SetDataRow,
  TotalLineAmtCalcualtion,
  pageSize,
  validToDate,
  validFromDate,
  generalFields
}) => {
  // Api Url
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")

  const priceEnterNoCount = 18
  const quantityEnterNoCount = 18

  //* useState for hold values for Single row *//
  const [RemTbl, SetRemTbl] = useState([{ proCode: 1, remark: "" }])

  const [multiplePriceEnable, setMultiplePriceEnable] = useState(false)
  const [multiplePrices, setMultiplePrices] = useState([])

  // const [ppDisable, setPPDisable] = useState(DisableDet)
  // const [weightavgDisable, SetWeightAvgDisable] = useState(DisableDet)

  const [detailAlertConfirmOption, setDetailAlertConfirmOption] = useState(0)
  const [detailPermissionAlertTitle, setDetailPermissionAlertTitle] = useState("")
  const [detailAlertShow, setDetailAlertShow] = useState(false)
  const [detalShowReason, setDetalShowReason] = useState(false)
  const [detailNameDisable, setDetailNameDisable] = useState(false)
  const [detailShowCancel, setDetailShowCancel] = useState(true)
  const [detailPermisonBtnColor, setDetailPermisonBtnColor] = useState("success")
  const [detailPermisonCancelColor, setDetailPermisonCancelColor] = useState("danger")
  const [detailAlertColor, setDetailAlertColor] = useState("danger")
  const [detailAlertMsg, setDetailAlertMsg] = useState("check")
  const [detailAlertResponseShow, setDetailAlertResponseShow] = useState(false)

  const [detailPermissionUsername, setDetailPermissionUsername] = useState("")
  const [detailPermissionPassword, setDetailPermissionPassword] = useState("")
  const [detailReason, setDetailReason] = useState("")
  const [detailPermissionMenuCode, setDetailPermissionMenuCode] = useState("")


  const [batchModelOpen, setBatchModelOpen] = useState(false)
  const [batchData, setBatchData] = useState([])
  const [productTax, setProductTax] = useState([])


  const [InvDataRow, SetInvDataRow] = useState([])
  const [fillRate, setFillRate] = useState(0)
  // const ApiURL = window.Links.ApiURL


  const [removeDisable, setRemoveDisable] = useState(false)

  const [DetailRemarks, setDetailRemarks] = useState([{ LineNo: FormRow.id, remark: '', key: 0 }])

  const detailLineRemarksNew = TaxLineRemarks.filter((x) => x.LineNo == FormRow.id)

  useEffect(() => {
    var newTable = TaxLineRemarks.filter((x) => x.LineNo != FormRow.id)

    DetailRemarks.map((x) => {
      newTable.push(x)
    })

    SetTaxLineRemarks(newTable)

  }, [DetailRemarks])

  useEffect(() => {
    setRemoveDisable(false)
  }, [currentDetailRows])



  useEffect(() => {

    if (TaxLineRemarks.filter((x) => x.LineNo == FormRow.id).length > 0) {
      setDetailRemarks(TaxLineRemarks.filter((x) => x.LineNo == FormRow.id))
    }

  }, [FormRow.id])


  useEffect(() => {
    calculateFillRate()

  }, [FormRow.dcDET_AMOUNT, RefDataRow])


  //* end useState for hold values for Single row *//
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_xlargeV, setmodal_xlargeV] = useState(false)
  const [modal_xlargeLine, setmodal_xlargeLine] = useState(false)

  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [sweetAlertShowCancel, setsweetAlertShowCancel] = useState(false)
  //const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  const [modelOpen_SOH, setmodelOpen_SOH] = useState(false)
  const [soh_modelData, setsoh_modelData] = useState({
    txnType: "",
    supplier: "",
    customer: "",
    productCode: "",
    stockCode: "",
    fromLocation: "",
    toLocation: "",
    beforeDate: "",
    afterDate: "",
  })


  async function clickSearch() {

    const isValidSuccess = await ProductSearchValidationsCheck();

    if (!isValidSuccess) {
      return;
    }

    tog_xlarge()
  }

  async function viewAllLocationSOH(productCode, stockCode) {

    if (stockCode == "") {
      return;
    }

    setsoh_modelData({
      txnType: txn.strTX_TYPE,
      supplier: supplierSelect,
      customer: customerSelect,
      productCode: productCode,
      stockCode: stockCode,
      fromLocation: loccode,
      toLocation: toLocationSelect,
      beforeDate: txn.intTX_AUTOORDER == 1 ? generalFields.autoOrderStartDate : validFromDate,
      afterDate: txn.intTX_AUTOORDER == 1 ? generalFields.autoOrderEndDate : validToDate,
      orderDays: parseInt(generalFields.autoOrderQty) || 0,
    })

    setmodelOpen_SOH(true)

  }




  //**Set the Default sort column and Sort order*/
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  function tog_xlargeV() {
    setmodal_xlargeV(!modal_xlargeV)
    removeBodyCss()
  }

  const CheckBalQty = async (colType, DET_CASEQTY, DET_UNITQTY) => {

    //reference doc is optional and no reference data means no ndeed to check balance qty
    if (txn.intTX_REFOPTIONAL == 1 && RefDataRow.length == 0) {
      return true
    }


    if (txn.intTX_REFQTYCHK == 1 && RefCode != null && RefCode.length > 0) {

      let enteredQTY = parseFloat(DET_CASEQTY) * parseFloat(FormRow.dcDET_CS) + parseFloat(DET_UNITQTY)

      if (parseFloat(FormRow.dcDET_BALQTY) < enteredQTY) {
        if (colType == 1) {
          changeRowValueChanges(0, FormRow.id, "dcDET_CASEQTY")
          LineAmtCalcualtion(DET_UNITQTY, 0, FormRow.dcDET_DISCPER, FormRow.dcDET_DISCAMT, DecimalValidation(FormRow.dcDET_FUNITQTY, 0, true, txnDecimalQty))
        } else if (colType == 2) {

          changeRowValueChanges(0, FormRow.id, "dcDET_UNITQTY")
          LineAmtCalcualtion(0, DET_CASEQTY, FormRow.dcDET_DISCPER, FormRow.dcDET_DISCAMT, DecimalValidation(FormRow.dcDET_FUNITQTY, 0, true, txnDecimalQty))

        }

        setDetailAlertShow(true)
        setDetailAlertConfirmOption(99)
        setDetailPermissionAlertTitle("Do you want to Enter More than Balance Quantity ?")
        setDetailPermissionMenuCode("P00015")

      }
    }

    return true;

  }


  useEffect(() => {
    TxnTotalCal()
  }, [FormRow.dcDET_AMOUNT, FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, FormRow.dcDET_DISCPER, FormRow.dcDET_DISCAMT, FormRow.dcDET_FUNITQTY])


  function tog_xlargeLine() {
    setmodal_xlargeLine(!modal_xlargeLine)
  }


  function tog_multiplePrice() {
    setMultiplePriceEnable(!multiplePriceEnable)
    removeBodyCss()
  }


  const Row_SelectMultiplePrice = async (e, row, isSelect, rowIndex) => {

    var currentRow = FormRow
    currentRow.dcDET_SPRICE_OLD = parseFloat(row.selling).toFixed(txnDecimalAmt)
    currentRow.dcDET_SPRICE = parseFloat(row.selling).toFixed(txnDecimalAmt)
    handleObjectChange(currentRow, FormRow.id)

    tog_multiplePrice()

  }


  //* Load Values According to re. Document */
  const CheckRefDocAvailable = (PRODUCTCODE, STOCKCODE) => {

    //if the reftxnis optional and no ref data found then return true it means this tranaction can add procudts without ref data
    if (txn.intTX_REFOPTIONAL == 1 && RefDataRow.length == 0) {
      return true
    }

    //if TX_IS_BATCH_TXN == 2 then only check the product code

    let objRefDataRow = txn.intTX_IS_BATCH_TXN == 2
      ? RefDataRow.find(o => o.strDET_PROCODE == PRODUCTCODE && o.strDET_STOCKCODE != "")
      : RefDataRow.find(o => o.strDET_PROCODE == PRODUCTCODE && o.strDET_STOCKCODE == STOCKCODE)

    if (objRefDataRow == null) {
      return false
    }

    return true

  }
  //* End Load Values According to re. Document */

  //* Calculation */
  const LineAmtCalcualtion = async (dcDET_UNITQTY, dcDET_CASEQTY, dcDET_DISCPER, dcDET_DISCAMT, dcDET_FUNITQTY, dcDET_CPRICE = FormRow.dcDET_CPRICE, dcDET_SPRICE = FormRow.dcDET_SPRICE) => {

    let currentdcDET_DISCAMT = dcDET_DISCAMT
    let currentRow = FormRow


    if (txn.intTX_ALLOWMINUS == 0 && txn.intTX_FREEQTYMINUS == 0) {
      if (parseFloat(currentdcDET_DISCAMT) > parseFloat(FormRow.dcDET_AMOUNT)) {
        changeRowValueChanges(parseFloat(0).toFixed(txnDecimalAmt), FormRow.id, "dcDET_DISCAMT")
        return
      }
    }

    if (currentdcDET_DISCAMT.toString().includes("*")) {
      let disc = currentdcDET_DISCAMT.substring(currentdcDET_DISCAMT.indexOf("*") + 1, currentdcDET_DISCAMT.length)
      disc = parseFloat(disc) * (parseFloat(FormRow.dcDET_CS) * parseFloat(dcDET_CASEQTY) + parseFloat(dcDET_UNITQTY))
      currentRow.dcDET_DISCAMT = disc
    }


    if (txn.intTX_SHOWVAR == 1) {
      let SysVar = 0.0

      let enterQty = parseFloat(dcDET_CASEQTY == "" ? 0 : dcDET_CASEQTY) * parseFloat(FormRow.dcDET_CS) + parseFloat(dcDET_UNITQTY == "" ? 0 : dcDET_UNITQTY)

      if (txn.intTX_REFQTYCHK == 1) {
        SysVar = parseFloat(FormRow.dcDET_BALQTY) - enterQty
      } else if (txn.intTX_CHKSIH == 1) {
        SysVar = parseFloat(FormRow.dcDET_SYSQTY) - enterQty
      } else {
        SysVar = parseFloat(enterQty) - parseFloat(FormRow.dcDET_SYSQTY)
      }
      currentRow.dcDET_VARQTY = SysVar

    }

    const isDecimalForFreeCase = (txn.intTX_VERIFICATION == 1 || txn.intTX_PRODUCTION == 1 || txn.intTX_BOM == 1) && FormRow.isDecimal == 1;

    const finishProduct = DataRow.find((data) => data.strDET_PROCODE == proSelect);

    let freeCaseQty = FormRow.dcDET_FCASEQTY

    if (txn.intTX_FREEQTYMINUS == 1 && proSelect != FormRow.strDET_PROCODE) {

      if (finishProduct && parseFloat(finishProduct.dcDET_FCASEQTY) > 0) {
        freeCaseQty = Math.abs(FormRow.dcDET_FCASEQTY) * -1
      } else {
        freeCaseQty = Math.abs(FormRow.dcDET_FCASEQTY)
      }

    }

    let freeUnitQty = dcDET_FUNITQTY
    if (txn.intTX_FREEQTYMINUS == 1 && txn.intTX_BOM == 0) {
      freeUnitQty = Math.abs(dcDET_FUNITQTY) * -1;
    }


    currentRow.dcDET_SPRICE = DecimalValidation(dcDET_SPRICE, 0, true, txnDecimalAmt)
    currentRow.dcDET_CPRICE = DecimalValidation(dcDET_CPRICE, 0, true, txnDecimalAmt)
    currentRow.dcDET_DISCAMT = DecimalValidation(currentdcDET_DISCAMT, 0, true, txnDecimalAmt)
    currentRow.dcDET_DISCPER = DecimalValidation(dcDET_DISCPER, 0, true, txnDecimalAmt)
    currentRow.dcDET_UNITQTY = DecimalValidation(dcDET_UNITQTY, 0, FormRow.isDecimal == 1 ? true : false, txnDecimalQty)
    currentRow.dcDET_CASEQTY = DecimalValidation(dcDET_CASEQTY, 0, false, 0)
    currentRow.dcDET_FUNITQTY = DecimalValidation(freeUnitQty, 0, FormRow.isDecimal == 1 ? true : false, txnDecimalQty)
    currentRow.dcDET_FCASEQTY = DecimalValidation(freeCaseQty, 0, isDecimalForFreeCase, txnDecimalQty)

    const modifiedGrid = await handleObjectChange(currentRow, FormRow.id)

    TxnTotalCal(modifiedGrid)

    return true
  }

  //*End Calculation */
  //**Row Select */

  const Hed_SelectRowSearch = async (e, row, isSelect, rowIndex) => {
    setmodal_xlarge(!modal_xlarge)//colse the search model

    if (row && row.PLU_CODE == undefined) {
      return;
    }

    var obj = {
      element: {
        target: {
          value: row.PLU_CODE,
          id: "DET_PROCODE" + Key
        }
      }
    }

    KeyPressEvnt(obj.element, Key, 13)

  }

  async function ProductSearchValidationsCheck() {
    if (txn.intTX_SUPITEMS == 1 && supplierSelect == "") {
      setAlertDescription("Please Select Supplier Before Add Products !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
      return false;
    }

    if (txn.intTX_SUPPLIER == 1 && supplierSelect == "") {
      setAlertDescription("Please Select Supplier Before Add Products !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
      return false;
    }

    if (loccode == "") {
      setAlertDescription("Please Select Location Before Add Products !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
      return false;
    }


    if (txn.intTX_SAVEINVOICE == 1 && customerSelect == "") {
      setAlertDescription("Please Select Customer Before Add Products !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
      return false;
    }

    if (txn.intTX_SHOWPRICEMODE == 1 && priceModeSelect == "") {
      setAlertDescription("Please Select Price Mode Before Add Products !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
      return false;
    }

    if (txn.strTX_DESTINV == 'N' || txn.strTX_DESTINV == '') {
    } else {
      if (toLocationSelect == "") {
        setAlertDescription("Please Select To Location Before Add Products !")
        setAlertConfirmOption(4)
        setsweetAlertShow(true)
        changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
        return false;
      }
    }

    return true;

  }


  //* Get data from Code OnBlur */
  let qty = "0"
  const GetProductDetailWithProCode = async code => {

    if (code == "") return

    if (code.includes("*")) {
      let fullText = code
      code = fullText.substring(fullText.indexOf("*") + 1, fullText.length)
      qty = fullText.substring(0, fullText.indexOf("*"))

    }

    try {


      const isValidationSuccess = await ProductSearchValidationsCheck();

      if (!isValidationSuccess) {
        return;
      }


      const selectedLocation = txn.intTX_SEARCHBY_TOLOC == 1 ? (toLocationSelect == "" ? loccode : toLocationSelect) : loccode;

      SetLoadingAlert(true)
      SetLoadingAlerttitle("Getting Product Details...")
      const { isSuccess, data } = await getProductDetailsCode(code, selectedLocation, txn.strTX_TYPE, supplierSelect, customerSelect)

      if (isSuccess) {
        const { m_TBLInventoryDetailsTxn, variantEnable, m_TBLTaxDetails, batchEnable } = data;

        if (m_TBLInventoryDetailsTxn !== null) {
          SetInvDataRow(m_TBLInventoryDetailsTxn);
        }

        if (variantEnable == 0 && batchEnable == 0) {
          SetDataToDetTable(data);
        }

        if (txn.intTX_VARIANT == 1 && variantEnable && m_TBLInventoryDetailsTxn.length == 1) {
          SetDataToDetTable(data);
          return
        } else if (txn.intTX_VARIANT == 1 && variantEnable) {
          setmodal_xlargeV(prevValue => !prevValue);
          setProductTax(m_TBLTaxDetails)
          return
        }

        if (batchEnable == 1 && (txn.intTX_IS_BATCH_TXN == 1 || txn.intTX_IS_BATCH_TXN == 2) && txn.intTX_CREATE_BATCH == 0 && m_TBLInventoryDetailsTxn.length > 1) {
          setBatchModelOpen(true)
          setBatchData(m_TBLInventoryDetailsTxn)
          setProductTax(m_TBLTaxDetails)
          return
        }

        SetDataToDetTable(data);

      } else {
        setAlertDescription("Product Not Found !");
        setAlertConfirmOption(4);
        setsweetAlertShow(true);
        changeRowValueChanges("", FormRow.id, "strDET_PROCODE");
      }

      return data

    } catch (error) {

      console.log(error)

    } finally {
      SetLoadingAlert(false)
    }

  }


  const SetDataToDetTable = async (PRODUCT) => { //set data to new row

    var dataRow = {
      dcDET_ACOST: 0,
      dcDET_AMOUNT: 0,
      dcDET_APRICE: 0,
      dcDET_BALQTY: 0,
      dcDET_FBALQTY: 0,
      dcDET_CASEQTY: 0,
      dcDET_CPRICE: 0,
      dcDET_CS: 1,
      dcDET_DISCAMT: 0,
      dcDET_DISCPER: 0,
      dcDET_FCASEQTY: 0,
      dcDET_FUNITQTY: 0,
      dcDET_OAPRICE: 0,
      dcDET_OCPRICE: 0,
      dcDET_OSPRICE: 0,
      dcDET_SPRICE: 0,
      dcDET_SYSQTY: 0,
      dcDET_UNITQTY: 0,
      dcDET_VARQTY: 0,
      dtDET_EXPCHECK: 0,
      dtDET_ISBATCH: 0,
      dtDET_EXPDAET: "1900-01-01",
      strDET_COMCODE: "",
      strDET_EXPBATCH: "",
      strDET_LOCCODE: "",
      strDET_PROCODE: "",
      strDET_PROCOLOR: "",
      strDET_PRODESC: "",
      strDET_PROSIZE: "",
      strDET_REMCODE: "",
      strDET_RUNNO: "",
      strDET_SACODE: "",
      strDET_STOCKCODE: "",
      strDET_TYPE: "",
      strDET_UNIT: "",
      disable: false,
      variant_ENABLE: false,
      dcDET_SPRICE_OLD: 0,
      dcDET_CPRICE_OLD: 0,
      dcDET_ACOST_OLD: 0,
      isDecimal: 0,
      dbPackPrice: 0,
      id: 1,
      openItem: 0,
      innerCS: [],
      defaultCS: 1,
      fixGP: 0,
    }

    const productExists = txn.intTX_IS_BATCH_TXN == 2
      ? DataRow.some(
        (x) =>
          x.strDET_PROCODE == PRODUCT.strProductCode &&
          x.strDET_STOCKCODE != ""
      )
      : DataRow.some(
        (x) =>
          x.strDET_PROCODE == PRODUCT.strProductCode &&
          x.strDET_STOCKCODE == PRODUCT.strStockCode
      )


    //this is for to add qty for the product
    if (AutoScan && productExists) {

      const existingProductIndex = DataRow.findIndex(
        (x) =>
          x.strDET_PROCODE == PRODUCT.strProductCode &&
          x.strDET_STOCKCODE == PRODUCT.strStockCode
      );

      if (existingProductIndex === -1) {
        // Handle the case where the product does not exist

        setAlertDescription("Product not found in the transaction !");
        setAlertConfirmOption(4);
        setsweetAlertShow(true);
        changeRowValueChanges("", FormRow.id, "strDET_PROCODE");

        return;
      }

      let existingProduct = { ...DataRow[existingProductIndex] };
      const currentRowIndex = DataRow.findIndex(
        (x) => x.id == FormRow.id
      );

      let currentRow = FormRow;
      let currentDataSet = [...DataRow];

      const unitQty = parseFloat(existingProduct.dcDET_UNITQTY) + 1;
      existingProduct.dcDET_UNITQTY = unitQty;

      // Reference doc is not optional
      if (txn.intTX_REFOPTIONAL == 0 && RefDataRow.length > 0 && txn.intTX_REFQTYCHK == 1 && RefCode && RefCode.length > 0) {
        let enteredQTY = parseFloat(existingProduct.dcDET_CASEQTY) * parseFloat(existingProduct.dcDET_CS) + parseFloat(unitQty);

        if (parseFloat(existingProduct.dcDET_BALQTY) < parseFloat(enteredQTY)) {
          setAlertDescription("You have entered more than balance quantity !");
          setAlertConfirmOption(4);
          setsweetAlertShow(true);
          changeRowValueChanges("", FormRow.id, "strDET_PROCODE");
          return;
        }
      }

      if (txn.intTX_SHOWPRICEMODE == 1 && priceModeSelect) {
        try {
          var proPrice = await getTxnProductPricemode(existingProduct.strDET_PROCODE, existingProduct.strDET_STOCKCODE, loccode, priceModeSelect, unitQty, txn.strTX_TYPE);
          if (proPrice.status == 1) {
            existingProduct.dcDET_SPRICE = parseFloat(proPrice.price) == 0 ? parseFloat(FormRow.dcDET_SPRICE_OLD).toFixed(txnDecimalAmt) : parseFloat(proPrice.price).toFixed(txnDecimalAmt);

            // Check if both discAmt and discPer are greater than 0, set discAmt to 0 if so
            if (parseFloat(proPrice.discAmt) > 0 && parseFloat(proPrice.discPer) > 0) {
              existingProduct.dcDET_DISCAMT = "0.00"; // Set discAmt to 0 if both are greater than 0
              existingProduct.dcDET_DISCPER = parseFloat(proPrice.discPer).toFixed(2);
            } else {
              // Set the appropriate value based on the availability of discAmt or discPer
              existingProduct.dcDET_DISCAMT = parseFloat(proPrice.discAmt) > 0
                ? parseFloat(proPrice.discAmt).toFixed(txnDecimalAmt)
                : "0.00";
              existingProduct.dcDET_DISCPER = parseFloat(proPrice.discPer) > 0
                ? parseFloat(proPrice.discPer).toFixed(2)
                : "0.00";
            }

          } else {
            existingProduct.dcDET_SPRICE = existingProduct.dcDET_SPRICE_OLD;
          }
        } catch (error) {
          console.error("Error fetching product price:", error);
          // Optionally set an error alert here
        }
      }

      currentRow.strDET_PROCODE = "";
      currentDataSet[existingProductIndex] = existingProduct;
      currentDataSet[currentRowIndex] = currentRow;

      var page = Math.ceil((existingProductIndex + 1) / pageSize);

      //set page number
      setPage(page);

      TotalLineAmtCalcualtion(currentDataSet);
      return;
    }

    if (txn.intTX_PLUREPEAT == 0) {

      const existingIndex = txn.intTX_IS_BATCH_TXN == 2
        ? DataRow.findIndex(
          (x) =>
            x.strDET_PROCODE == PRODUCT.strProductCode &&
            x.strDET_STOCKCODE != ""
        ) : DataRow.findIndex(
          (x) =>
            x.strDET_PROCODE == PRODUCT.strProductCode &&
            x.strDET_STOCKCODE == PRODUCT.strStockCode
        )

      const showAlertForDuplicateProduct = () => {
        setAlertDescription(`Product Already Added to line no ${existingIndex + 1}`);
        setAlertConfirmOption(4);
        setsweetAlertShow(true);
        changeRowValueChanges("", FormRow.id, "strDET_PROCODE");
      };

      const isBatchCreation = txn.intTX_CREATE_BATCH == 1;
      const isBatchDisabled = PRODUCT.batchEnable == 0;

      if (productExists) {
        if (isBatchCreation) {
          if (isBatchDisabled) {
            showAlertForDuplicateProduct();
            return;
          }
        } else {
          showAlertForDuplicateProduct();
          return;
        }
      }
    } else {

      if (productExists) {
        setAlertDescription("This product already exists in the transaction, but you can add it again.")
        setAlertConfirmOption(4)
        setsweetAlertShow(true)
      }

    }


    if (txn.strTX_REFTYPES != "" && txn.strTX_REFTYPES != null) {
      let refOk = CheckRefDocAvailable(PRODUCT.strProductCode, PRODUCT.strStockCode)
      if (!refOk) {
        setAlertDescription("Selected item not in Referred Document !")
        setAlertConfirmOption(4)
        setsweetAlertShow(true)
        changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
        return
      }
    }

    debugger
    const referenceItem = await findItemReferenceForNewArray(PRODUCT.strProductCode, PRODUCT.strStockCode, RefDataRow, DataRow, txn)

    if (txn.intTX_FIFO == 1) {
      dataRow.id = FormRow?.id || 1 //set id to the row
    } else {
      if (referenceItem) {
        const itemExists = DataRow.some(i => i.id == referenceItem.id);
        if (itemExists) {
          dataRow.id = FormRow?.id || 1
        } else {
          dataRow.id = referenceItem.id
        }
      } else {
        dataRow.id = FormRow?.id || 1
      }

    }


    if (txn.intTX_OPENONLY == 1 && PRODUCT.isOpen == 0) {
      setAlertDescription("Selected item is not an open item !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
      return
    }
    if (txn.intTX_EXCLOPEN == 1 && PRODUCT.isOpen == 1) {
      setAlertDescription("Selected item is an open item !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
      return
    }
    if (txn.intTX_RAWONLY == 1 && PRODUCT.dbRawItem == 0) {
      setAlertDescription("Selected item is not an raw item !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
      return
    }

    if (txn.intTX_EXCLRAW == 1 && PRODUCT.dbRawItem == 1) {
      setAlertDescription("Selected item is an raw item !")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
      changeRowValueChanges("", FormRow.id, "strDET_PROCODE")
      return
    }


    dataRow.strDET_PROCODE = PRODUCT.strProductCode
    dataRow.strDET_PRODESC = PRODUCT.strProductDesc
    dataRow.strDET_STOCKCODE = PRODUCT.strStockCode
    dataRow.dtDET_EXPCHECK = PRODUCT.isExp
    dataRow.isDecimal = PRODUCT.isDecimal

    if (txn.intTX_FIFO == 1) {

      dataRow.dcDET_CPRICE = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_SPRICE = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
      dataRow.dcDET_SPRICE_OLD = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
      dataRow.dcDET_CPRICE_OLD = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
      dataRow.dbPackPrice = parseFloat(PRODUCT.dbPackPrice).toFixed(txnDecimalAmt)
      dataRow.dbAvgCost = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_ACOST = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_ACOST_OLD = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_SYSQTY = parseFloat(PRODUCT.dbSIH).toFixed(txnDecimalQty)
      dataRow.dcDET_OCPRICE = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_OSPRICE = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
      dataRow.dcDET_OAPRICE = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_APRICE = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_CASEQTY = 0
      dataRow.dcDET_UNITQTY = 0
      dataRow.dcDET_BALQTY = 0
      dataRow.dcDET_FBALQTY = 0
      dataRow.dcDET_CS = PRODUCT.dbCaseSize != 0 ? PRODUCT.dbCaseSize : 1

    } else if (txn.intTX_REFPRICE == 1 && referenceItem != null) {

      dataRow.dcDET_CPRICE = parseFloat(referenceItem.dcDET_CPRICE).toFixed(txnDecimalAmt)
      dataRow.dcDET_SPRICE = parseFloat(referenceItem.dcDET_SPRICE).toFixed(txnDecimalAmt)
      dataRow.dcDET_SPRICE_OLD = parseFloat(referenceItem.dcDET_SPRICE).toFixed(txnDecimalAmt)
      dataRow.dcDET_CPRICE_OLD = parseFloat(referenceItem.dcDET_CPRICE).toFixed(txnDecimalAmt)
      dataRow.dbPackPrice = parseFloat(referenceItem.dcDET_SPRICE).toFixed(txnDecimalAmt)
      dataRow.dcDET_SYSQTY = parseFloat(referenceItem.dcDET_SYSQTY).toFixed(txnDecimalQty)
      dataRow.dcDET_ACOST = parseFloat(referenceItem.dcDET_ACOST).toFixed(txnDecimalAmt)
      dataRow.dcDET_ACOST_OLD = parseFloat(referenceItem.dcDET_ACOST).toFixed(txnDecimalAmt)
      dataRow.dbAvgCost = parseFloat(referenceItem.dcDET_ACOST).toFixed(txnDecimalAmt)
      dataRow.dcDET_OCPRICE = parseFloat(referenceItem.dcDET_OCPRICE).toFixed(txnDecimalAmt)
      dataRow.dcDET_OSPRICE = parseFloat(referenceItem.dcDET_OSPRICE).toFixed(txnDecimalAmt)
      dataRow.dcDET_OAPRICE = parseFloat(referenceItem.dcDET_OAPRICE).toFixed(txnDecimalAmt)
      dataRow.dcDET_APRICE = parseFloat(referenceItem.dcDET_ACOST).toFixed(txnDecimalAmt)
      dataRow.dcDET_CASEQTY = referenceItem.dcDET_CASEQTY
      dataRow.dcDET_UNITQTY = referenceItem.dcDET_UNITQTY
      dataRow.dcDET_BALQTY = referenceItem.dcDET_BALQTY
      dataRow.dcDET_FBALQTY = referenceItem.dcDET_FBALQTY
      dataRow.dcDET_CS = referenceItem != null ? referenceItem.dcDET_CS : PRODUCT.dbCaseSize

    } else {

      dataRow.dcDET_CPRICE = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_SPRICE = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
      dataRow.dcDET_SPRICE_OLD = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
      dataRow.dcDET_CPRICE_OLD = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
      dataRow.dbPackPrice = parseFloat(PRODUCT.dbPackPrice).toFixed(txnDecimalAmt)
      dataRow.dbAvgCost = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_ACOST = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_ACOST_OLD = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_SYSQTY = parseFloat(PRODUCT.dbSIH).toFixed(txnDecimalQty)
      dataRow.dcDET_OCPRICE = parseFloat(PRODUCT.dbCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_OSPRICE = parseFloat(PRODUCT.dbSelling).toFixed(txnDecimalAmt)
      dataRow.dcDET_OAPRICE = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_APRICE = parseFloat(PRODUCT.dbAvgCost).toFixed(txnDecimalAmt)
      dataRow.dcDET_CASEQTY = 0
      dataRow.dcDET_UNITQTY = 0
      dataRow.dcDET_BALQTY = referenceItem != null ? referenceItem.dcDET_BALQTY : 0
      dataRow.dcDET_FBALQTY = referenceItem != null ? referenceItem.dcDET_FBALQTY : 0
      dataRow.dcDET_CS = referenceItem != null ? referenceItem.dcDET_CS : PRODUCT.dbCaseSize
    }

    dataRow.defaultCS = PRODUCT.dbCaseSize != 0 ? PRODUCT.dbCaseSize : 1
    dataRow.innerCS = PRODUCT.innerCaseSizesList
    dataRow.strDET_UNIT = PRODUCT.strUnitDesc
    dataRow.openItem = PRODUCT.isOpen
    dataRow.dtDET_ISBATCH = PRODUCT.batchEnable
    dataRow.dtDET_EXPDAET = PRODUCT.pluExpiery.slice(0, 10)
    dataRow.disable = true
    dataRow.strDET_REMCODE = reasonForDetails != null && reasonForDetails != "" ? reasonForDetails : ""
    dataRow.strDET_PROSIZE = PRODUCT.variant2
    dataRow.strDET_PROCOLOR = PRODUCT.variant1
    dataRow.fixGP = PRODUCT.dbFixGp != null ? PRODUCT.dbFixGp : 0;


    if (qty !== "0" && !isNaN(qty)) {  // Check if qty is a valid number and not "0"

      // Ensure qty is a number and apply the absolute value based on the txn.intTX_ALLOWMINUS flag
      qty = txn.intTX_ALLOWMINUS === 1 ? qty : Math.abs(parseFloat(qty));

      // Determine the number of decimal places
      const decimalPlaces = dataRow.isDecimal == 1 ? txnDecimalQty : 0;

      // Assign the quantity to the correct field based on intTX_UNITQTY
      if (txn.intTX_UNITQTY == 1) {
        dataRow.dcDET_UNITQTY = parseFloat(qty).toFixed(decimalPlaces);
      } else {
        dataRow.dcDET_CASEQTY = parseFloat(qty).toFixed(decimalPlaces);
      }

    }

    const taxDetails = PRODUCT.m_TBLTaxDetails;
    const hasValidTax = taxDetails && taxDetails.length > 0 && txn.inTX_TAX === 1;

    if (hasValidTax) { //if item have tax go inside

      const calculatedTax = await CalculateTaxWithTransactionRelatedTax(txnTaxTypes, taxTable, taxDetails, FormRow.dcDET_AMOUNT, PRODUCT.strProductDesc, dataRow.id, txnDecimalAmt)
      SetTaxTable(calculatedTax)

    }


    if (PRODUCT.isOpen == 0 && txn.intTX_SCANBARCODE == 1 && AutoScan == true) {
      if (txn.intTX_UNITQTY == 1) {
        dataRow.dcDET_UNITQTY = 1
      } else if (txn.intTX_CASEQTY == 1) {
        dataRow.dcDET_CASEQTY = 1
      }
    }


    handleObjectChange(dataRow, FormRow.id)

    if (txn.intTX_SHOWMULTIPLE_PRICE == 1 && txn.strTX_PRICEMODE == "S" || txn.strTX_PRICEMODE == 's') {
      var multipleObj = await GetMultiplePrices(PRODUCT.strProductCode, loccode)

      if (multipleObj.data.length > 0) {
        setMultiplePrices(multipleObj.data)
        tog_multiplePrice()
      }
    }


  }

  const CalculateVariantItemsTax = async (itemList) => {

    CalcualteVariantTax(txnTaxTypes, taxTable, SetTaxTable, productTax, txnDecimalAmt, itemList)

  }



  //* Enter Key press */
  const KeyPressEvnt = async (e, Key, cusKeyCode = 0) => {

    let cost = document.getElementById("DET_CPRICE" + Key)
    let sell = document.getElementById("DET_SPRICE" + Key)
    let avg = document.getElementById("DET_ACOST" + Key)
    let pp = document.getElementById("DET_PPRICE" + Key)


    if (e.charCode == 13 || cusKeyCode == 13) {

      if (cusKeyCode == 13 || e.target.id == "DET_PROCODE" + Key) {

        if (e.target.value == "" && cusKeyCode != 13) {
          document.getElementById("btnSearch" + Key).focus()
          return
        }

        let onBlurResponse = await GetProductDetailWithProCode(e.target.value)
        if (onBlurResponse != null && onBlurResponse.length > 0) {

          if (FormRow.openItem == false && txn.intTX_SCANBARCODE == 1 && AutoScan == true && txn.intTX_EXPCHKSIH == 0 && txn.intTX_CHANGEPRICE == 0) {
            let newRowAdded = await AddRow()
            if (newRowAdded == -1) {
              setTimeout(() => {
                const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
                if (element) {
                  element.focus()
                }
              }, 150)
            } else {
              document
                .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
                .focus()
            }
          }
          if (FormRow.openItem) {
            document.getElementById("DET_PRODESC" + Key).focus()
            return
          } else if (txn.intTX_EXPCHKSIH == 1) {
            document.getElementById("DET_EXPDATE" + Key).focus()
            return
          } else if (cost != null && cost.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1 && txn.intTX_CHANGEPRICE == 1) {
            document.getElementById("DET_CPRICE" + Key).focus()
            return
          } else if (sell != null && sell.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1 && txn.intTX_CHANGEPRICE == 1) {
            sell.focus()
            return
          } else if (
            avg != null &&
            avg.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1
          ) {
            avg.focus()
            return
          } else if (
            pp != null &&
            pp.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1
          ) {
            pp.focus()
            return
          } else if (txn.intTX_CASEQTY != 0) {
            document.getElementById("DET_CASEQTY" + Key).focus()
            return
          } else if (txn.intTX_UNITQTY != 0) {
            document.getElementById("DET_UNITQTY" + Key).focus()
            return
          } else if (txn.intTX_FREEUNITQTY != 0) {
            document.getElementById("DET_FUNITQTY" + Key).focus()
            return
          } else if (txn.intTX_FREECASEQTY != 0) {
            document.getElementById("DET_FCASEQTY" + Key).focus()
            return
          } else if (txn.intTX_LINEDISCPER != 0) {
            document.getElementById("DET_DISCPER" + Key).focus()
            return
          } else if (txn.intTX_LINEDISCAMT != 0) {
            document.getElementById("DET_DISCAMT" + Key).focus()
            return
          } else if (txn.intTX_LINEREMARKS == 1) {
            document.getElementById("DET_REMCODE" + Key).focus()
            return
          } else {
            let newRowAdded = await AddRow()
            if (newRowAdded != false) {
              setTimeout(() => {
                const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
                if (element) {
                  element.focus()
                }
              }, 150)
            }
            return
          }
        } else {
          return
        }
      }
      if (e.target.id == "DET_PRODESC" + Key) {
        if (txn.intTX_EXPCHKSIH == 1) {
          document.getElementById("DET_EXPDATE" + Key).focus()
          return
        } else if (cost != null && ccost.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1 && txn.intTX_CHANGEPRICE == 1) {
          cost.focus()
          return
        } else if (sell != null && sell.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1 && txn.intTX_CHANGEPRICE == 1) {
          sell.focus()
          return
        } else if (
          avg != null &&
          avg.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1
        ) {
          avg.focus()
          return
        } else if (
          pp != null &&
          pp.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1
        ) {
          pp.focus()
          return
        } else if (txn.intTX_CASEQTY != 0) {
          document.getElementById("DET_CASEQTY" + Key).focus()
          return
        } else if (txn.intTX_UNITQTY != 0) {
          document.getElementById("DET_UNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_CPRICE" + Key) {
        if (sell != null && sell.style.visibility == "visible") {
          sell.focus()
          return
        } else if (avg != null && avg.style.visibility == "visible") {
          avg.focus()
          return
        } else if (pp != null && pp.style.visibility == "visible") {
          pp.focus()
          return
        } else if (txn.intTX_CASEQTY != 0) {
          document.getElementById("DET_CASEQTY" + Key).focus()
          return
        } else if (txn.intTX_UNITQTY != 0) {
          document.getElementById("DET_UNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_SPRICE" + Key) {
        if (AlertConfirmOption == 100) {
          return
        }
        if (avg != null && avg.style.visibility == "visible") {
          avg.focus()
          return
        } else if (pp != null && pp.style.visibility == "visible") {
          pp.focus()
          return
        } else if (txn.intTX_CASEQTY != 0) {
          document.getElementById("DET_CASEQTY" + Key).focus()
          return
        } else if (txn.intTX_UNITQTY != 0) {
          document.getElementById("DET_UNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_EXPDATE" + Key) {
        if (cost != null && cost.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1) {
          cost.focus()
          return
        } else if (sell != null && sell.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1) {
          sell.focus()
          return
        } else if (
          avg != null &&
          avg.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1
        ) {
          avg.focus()
          return
        } else if (
          pp != null &&
          pp.style.visibility == "visible" && txn.intTX_CHANGEPRICE == 1
        ) {
          pp.focus()
          return
        } else if (txn.intTX_CASEQTY != 0) {
          document.getElementById("DET_CASEQTY" + Key).focus()
          return
        } else if (txn.intTX_UNITQTY != 0) {
          document.getElementById("DET_UNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_CPRICE" + Key) {
        if (sell != null && sell.style.visibility == "visible") {
          sell.focus()
          return
        } else if (avg != null && avg.style.visibility == "visible") {
          avg.focus()
          return
        } else if (pp != null && pp.style.visibility == "visible") {
          pp.focus()
          return
        } else if (txn.intTX_CASEQTY != 0) {
          document.getElementById("DET_CASEQTY" + Key).focus()
          return
        } else if (txn.intTX_UNITQTY != 0) {
          document.getElementById("DET_UNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_SPRICE" + Key) {
        if (AlertConfirmOption == 100) {
          return
        }
        if (avg != null && avg.style.visibility == "visible") {
          avg.focus()
          return
        } else if (pp != null && pp.style.visibility == "visible") {
          pp.focus()
          return
        } else if (txn.intTX_CASEQTY != 0) {
          document.getElementById("DET_CASEQTY" + Key).focus()
          return
        } else if (txn.intTX_UNITQTY != 0) {
          document.getElementById("DET_UNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_ACOST" + Key) {
        if (pp != null && pp.style.visibility == "visible") {
          pp.focus()
          return
        } else if (txn.intTX_CASEQTY != 0) {
          document.getElementById("DET_CASEQTY" + Key).focus()
          return
        } else if (txn.intTX_UNITQTY != 0) {
          document.getElementById("DET_UNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_PPRICE" + Key) {
        if (txn.intTX_CASEQTY != 0) {
          document.getElementById("DET_CASEQTY" + Key).focus()
          return
        } else if (txn.intTX_UNITQTY != 0) {
          document.getElementById("DET_UNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_CASEQTY" + Key) {
        if (AlertConfirmOption == 100) {
          sell.focus()
          return
        }
        if (txn.intTX_UNITQTY != 0) {
          document.getElementById("DET_UNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_UNITQTY" + Key) {
        if (AlertConfirmOption == 100) {
          sell.focus()
          return
        }

        if (txn.intTX_SHOWVAR == 1) {
          let sihVal = document.getElementById("DET_SYSQTY" + Key).value
          let unitVal = document.getElementById("DET_UNITQTY" + Key).value
          let valT = parseFloat(unitVal) - parseFloat(sihVal)

          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
        }


        if (txn.intTX_FREEUNITQTY != 0) {
          document.getElementById("DET_FUNITQTY" + Key).focus()
          return
        } else if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 10)
          } else {

            // document
            //   .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
            //   .focus()
          }
          return
        }
      }
      if (e.target.id == "DET_FUNITQTY" + Key) {
        if (AlertConfirmOption == 100) {
          sell.focus()
          return
        }
        //* Only for SVN transaction */
        if (txn.strTX_TYPE == "SVN") {
          if (parseFloat(FormRow.dcDET_UNITQTY) > 0 && parseFloat(FormRow.dcDET_FUNITQTY) > 0) {
            // setfunitQty("0")
            changeRowValueChanges(0, FormRow.id, "dcDET_FUNITQTY")
          }
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            document
              .getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
              .focus()
          }
          return
        }

        //* End SVN transaction Validation*/
        if (txn.intTX_FREECASEQTY != 0) {
          document.getElementById("DET_FCASEQTY" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCAMT != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEREMARKS == 1) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
            if (element) {
              element.focus()
            }
          }
          return
        }
      }
      if (e.target.id == "DET_FCASEQTY" + Key) {
        if (AlertConfirmOption == 100) {
          sell.focus()
          return
        }
        if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCPER" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_DISCAMT" + Key).focus()
          return
        } else if (txn.intTX_LINEDISCPER != 0) {
          document.getElementById("DET_REMCODE" + Key).focus()
          return
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          } else {
            const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
            if (element) {
              element.focus()
            }
          }
          return
        }
      }
      if (e.target.id == "DET_DISCPER" + Key) {
        if (AlertConfirmOption == 100) {
          sell.focus()
          return
        }
        if (txn.intTX_LINEDISCPER != 0) {
          // document.getElementById("DET_DISCAMT" + Key).focus()
          const element = document.getElementById("DET_DISCAMT" + Key)
          if (element) {
            element.focus()
          }
        } else if (txn.intTX_LINEDISCPER != 0) {
          const element = document.getElementById("DET_REMCODE" + Key).focus()
          if (element) {
            element.focus()
          }
        } else {
          let newRowAdded = await AddRow()
          if (newRowAdded != false) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          }
          return
        }
      }
      if (e.target.id == "DET_DISCAMT" + Key) {

        if (AlertConfirmOption == 100) {
          sell.focus()
          return
        }
        if (parseFloat(FormRow.dcDET_DISCAMT) > parseFloat(FormRow.dcDET_AMOUNT)) {

          await changeRowValueChanges(parseFloat(0).toFixed(txnDecimalAmt), FormRow.id, "dcDET_DISCAMT")
        }
        if (FormRow.dcDET_DISCAMT.toString().includes("*")) {
          let disc = FormRow.dcDET_DISCAMT.substring(FormRow.dcDET_DISCAMT.indexOf("*") + 1, FormRow.dcDET_DISCAMT.length)
          disc = parseFloat(disc) * (parseFloat(FormRow.dcDET_CS) * parseFloat(FormRow.dcDET_CASEQTY) + parseFloat(FormRow.dcDET_UNITQTY))

          await changeRowValueChanges(disc, FormRow.id, "dcDET_DISCAMT")
        }
        if (txn.intTX_LINEREMARKS == 1) {
          setTimeout(() => {
            document.getElementById("DET_REMCODE" + Key).focus()
          }, 150)
          return
        } else {
          let newRowAdded = await AddRow()

          if (newRowAdded == -1) {
            setTimeout(() => {
              const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
              if (element) {
                element.focus()
              } else {
                setPage(prev => prev + 1)
                document.getElementById("DET_PROCODE0").focus()
              }
            }, 150)
          }
          else {
            const element = document.getElementById("DET_PROCODE" + (newRowAdded))
            if (element) {
              element.focus()
            }
          }
          return
        }
      }
      if (e.target.id == "DET_REMCODE" + Key) {
        if (AlertConfirmOption == 100) {
          sell.focus()
          return
        }
        let newRowAdded = await AddRow()
        if (newRowAdded == -1) {
          setTimeout(() => {
            const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
            if (element) {
              element.focus()
            }
          }, 150)
        } else {
          const element = document.getElementById("DET_PROCODE" + (parseInt(Key) + newRowAdded))
          if (element) {
            element.focus()
          }
        }
        return
      }
    }
  }



  const MenuUserpermission = operation => {



    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]

    const permissiondata = {
      strUsername: detailPermissionUsername,
      strPassword: detailPermissionPassword,
      strLocation: LocationCode,
      strMenuCode: detailPermissionMenuCode,
    }

    var currentRow = FormRow
    //
    fetch(`${ApiURL}login/userpermission`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(permissiondata),
    })
      .then(async (Response) => {
        if (Response.status == "200") {
          Response.json().then(async (responseData) => {
            let Access = responseData.data.strMenuAccessRight
            let Create = responseData.data.strMenuCreateRight
            let Delete = responseData.data.strMenuDeleteRight
            let Modify = responseData.data.strMenuModifyRight
            let Print = responseData.data.strMenuPrintRight
            let Process = responseData.data.strMenuProcessRight

            setDetailPermissionUsername("")
            setDetailPermissionPassword("")
            setDetailReason("")

            if (operation == "Access" && Access == true) {
              setDetailAlertColor("success")
              setDetailAlertMsg("Permission Granted !")
              setDetailAlertResponseShow(true)

              setTimeout(() => {
                setDetailAlertResponseShow(false)
                setDetailAlertShow(false)
              }, 1000);



              if (detailAlertConfirmOption == 97) {
                const currQty = parseFloat(currentRow.dcDET_UNITQTY) + (parseFloat(currentRow.dcDET_CS) * parseFloat(currentRow.dcDET_CASEQTY))

                if (txn.intTX_SHOWPRICEMODE == 1 && priceModeSelect != "") { //if price mode is enabled then get the price according to the price mode

                  var proPrice = await getTxnProductPricemode(currentRow.strDET_PROCODE, currentRow.strDET_STOCKCODE, loccode, priceModeSelect, currQty, txn.strTX_TYPE) //get product price according to the payment mode

                  if (proPrice.status == 1) {              //if product price is available then set the price
                    currentRow.dcDET_SPRICE = parseFloat(proPrice.price) == 0 ? parseFloat(FormRow.dcDET_SPRICE_OLD).toFixed(txnDecimalAmt) : parseFloat(proPrice.price).toFixed(txnDecimalAmt)
                    // currentRow.dcDET_DISCAMT = parseFloat(proPrice.discAmt).toFixed(txnDecimalAmt)
                    // currentRow.dcDET_DISCPER = parseFloat(proPrice.discPer).toFixed(2)

                    // Check if both discAmt and discPer are greater than 0, set discAmt to 0 if so
                    if (parseFloat(proPrice.discAmt) > 0 && parseFloat(proPrice.discPer) > 0) {
                      currentRow.dcDET_DISCAMT = "0.00"; // Set discAmt to 0 if both are greater than 0
                      currentRow.dcDET_DISCPER = parseFloat(proPrice.discPer).toFixed(2);
                    } else {
                      // Set the appropriate value based on the availability of discAmt or discPer
                      currentRow.dcDET_DISCAMT = parseFloat(proPrice.discAmt) > 0
                        ? parseFloat(proPrice.discAmt).toFixed(txnDecimalAmt)
                        : "0.00";
                      currentRow.dcDET_DISCPER = parseFloat(proPrice.discPer) > 0
                        ? parseFloat(proPrice.discPer).toFixed(2)
                        : "0.00";
                    }

                  } else {                                //if product price is not available then set the old price
                    currentRow.dcDET_SPRICE = FormRow.dcDET_SPRICE_OLD
                  }
                }
              }

              handleObjectChange(currentRow, FormRow.id)

            } else {

              setDetailAlertColor("danger")
              setDetailAlertMsg("You have not Permission to make changes !")
              setDetailAlertResponseShow(true)

              setTimeout(() => {
                setDetailAlertResponseShow(false)
                setDetailAlertShow(false)
              }, 2000);

              if (detailAlertConfirmOption == 97) {

                currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
                currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)

                handleObjectChange(currentRow, FormRow.id) //set new values to the row object

              } else if (detailAlertConfirmOption == 99) {

                currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
                currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)

                handleObjectChange(currentRow, FormRow.id) //set new values to the row object

              } else if (detailAlertConfirmOption == 101) {

                currentRow.dcDET_SPRICE = parseFloat(currentRow.dcDET_SPRICE_OLD).toFixed(txnDecimalAmt)

              } else if (detailAlertConfirmOption == 96) {
                currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
                currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)
                handleObjectChange(currentRow, FormRow.id)
              }


            }
          })
        } else if (Response.status == "400") {
          setAlertColor("danger")
          setAlertMsg("Oops something went wrong !")
          setDetailPermissionUsername("")
          setDetailPermissionPassword("")
          setDetailReason("")
          setShow(true)

          if (detailAlertConfirmOption == 99) {

            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)

            handleObjectChange(currentRow, FormRow.id)
          } else if (detailAlertConfirmOption == 97) {

            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)

            currentRow.dcDET_DISCAMT = priceModeSelect != "" ? 0 : parseFloat(FormRow.dcDET_DISCAMT).toFixed(txnDecimalAmt)
            currentRow.dcDET_DISCPER = priceModeSelect != "" ? 0 : parseFloat(FormRow.dcDET_DISCPER).toFixed(2)

            handleObjectChange(currentRow, FormRow.id)

          } else if (detailAlertConfirmOption == 96) {
            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)
          }

        } else if (Response.status == "403") {

          setDetailPermissionUsername("")
          setDetailPermissionPassword("")
          setDetailReason("")

          setDetailAlertColor("danger")
          setDetailAlertMsg("You have not Permission to make changes !")
          setDetailAlertResponseShow(true)

          setTimeout(() => {
            setDetailAlertResponseShow(false)
            setDetailAlertShow(false)
          }, 2000);


          if (detailAlertConfirmOption == 99) {

            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)

            handleObjectChange(currentRow, FormRow.id)
          } else if (detailAlertConfirmOption == 97) {

            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)

            currentRow.dcDET_DISCAMT = priceModeSelect != "" ? 0 : parseFloat(FormRow.dcDET_DISCAMT).toFixed(txnDecimalAmt)
            currentRow.dcDET_DISCPER = priceModeSelect != "" ? 0 : parseFloat(FormRow.dcDET_DISCPER).toFixed(2)

            handleObjectChange(currentRow, FormRow.id)

          } else if (detailAlertConfirmOption == 96) {
            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)
          }

        } else if (Response.status == "404") {

          setDetailPermissionUsername("")
          setDetailPermissionPassword("")
          setDetailReason("")

          setDetailAlertColor("danger")
          setDetailAlertMsg("Password or User Name is Invalid !")
          setDetailAlertResponseShow(true)

          setTimeout(() => {
            setDetailAlertResponseShow(false)
            setDetailAlertShow(false)
          }, 2000);



          if (detailAlertConfirmOption == 99) {

            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)

            handleObjectChange(currentRow, FormRow.id)
          } else if (detailAlertConfirmOption == 97) {

            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)

            currentRow.dcDET_DISCAMT = priceModeSelect != "" ? 0 : parseFloat(FormRow.dcDET_DISCAMT).toFixed(txnDecimalAmt)
            currentRow.dcDET_DISCPER = priceModeSelect != "" ? 0 : parseFloat(FormRow.dcDET_DISCPER).toFixed(2)

            handleObjectChange(currentRow, FormRow.id)
          } else if (detailAlertConfirmOption == 96) {
            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)
          }

        }
      })
      .catch(error => {
        console.log(error.message)
      })

    //notification disable function
    setTimeout(() => {
      setShow(false)
    }, 6000)
  }

  async function addNewRowOnClickReason() {
    let newRowAdded = await AddRow()
    if (newRowAdded == -1) {
      setTimeout(() => {
        var elementdata = document.getElementById("DET_PROCODE" + (parseInt(Key) + 1))
        if (elementdata) {
          elementdata.focus()
        }
      }, 10)
    } else {
      var elementData = document.getElementById("DET_PROCODE" + (parseInt(Key)))
      if (elementData) {
        elementData.focus()
      }
    }
  }



  /*
    This calculateFillRate function is used to calculate the fill rate of the product line wise.
    If unitqty enabled it calculate fill rate using unit qty , if case qty enabled fill rate calculate by multiplying case qty by case size
  */

  function calculateFillRate() {

    let totalQty = 0
    let totalFill = 0
    let totalFillRate = 0
    let totalFillRatePer = 0
    let totalFillRatePerRound = 0

    let objRefDataRow = RefDataRow.find(o => {
      return o.strDET_PROCODE == FormRow.strDET_PROCODE
    })

    if (objRefDataRow) {
      if (txn.intTX_UNITQTY == 1) {
        totalQty = parseFloat(objRefDataRow.dcDET_UNITQTY) + parseFloat(objRefDataRow.dcDET_CASEQTY) * parseFloat(objRefDataRow.dcDET_CS)
        totalFill = FormRow.dcDET_UNITQTY
      } else if (txn.intTX_CASEQTY == 1) {
        totalQty = parseFloat(objRefDataRow.dcDET_UNITQTY) + parseFloat(objRefDataRow.dcDET_CASEQTY) * parseFloat(objRefDataRow.dcDET_CS)
        totalFill = parseFloat(FormRow.dcDET_CASEQTY) * parseFloat(FormRow.dcDET_CS)
      }

      if (totalFill == 0 && totalQty == 0) {
        totalFillRate = 0
      } else {
        totalFillRate = totalFill / totalQty
      }

      totalFillRatePer = totalFillRate * 100
      totalFillRatePerRound = parseFloat(totalFillRatePer).toFixed(2)
    }

    setFillRate(totalFillRatePerRound)
  }


  /**
   *  This function is used to set the focus to the next empty text box
   *  when the user press the enter key on alert box
   */

  function SetFocusToNextEmptyTextBox() {
    //get the empty text box id
    var indexOfProduct = DataRow.findIndex((items) => items.strDET_STOCKCODE == "");

    if (indexOfProduct != -1) {
      var page = Math.ceil((indexOfProduct + 1) / 10);
      setPage(page);

      setTimeout(() => {
        var element = document.getElementById("DET_PROCODE" + indexOfProduct);
        if (element) {
          element.focus();
        }
      }, 500);
    }
  }

  const proCodeRef = useRef(null)

  function CalculateCurrentGP(selling, cost, caseSize) {
    let calculatedGP = (((parseFloat(selling) - (parseFloat(cost) / parseFloat(caseSize))) / parseFloat(selling)) * 100);
    return isNaN(calculatedGP) ? 0 : parseFloat(calculatedGP).toFixed(2);
  }

  function CompareGP(currentSelling, currentCost, oldSelling, oldCost, caseSize) {
    const currentGP = parseFloat(CalculateCurrentGP(currentSelling, currentCost, caseSize));
    const oldGP = parseFloat(CalculateCurrentGP(oldSelling, oldCost, caseSize));

    if (currentGP === oldGP) return 0;
    return currentGP > oldGP ? 1 : -1;
  }

  //get current gp difference
  const currentRowGP = CompareGP(FormRow.dcDET_SPRICE, FormRow.dcDET_CPRICE, FormRow.dcDET_SPRICE_OLD, FormRow.dcDET_CPRICE_OLD, FormRow.dcDET_CS)
  const gpColor = currentRowGP == 0 ? "" : currentRowGP > 0 ? "#33C08D" : "#F46A6A"


  return (

    <tr key={FormRow.id}>
      <td>

        <TransactionBatchModel
          isOpen={batchModelOpen}
          toggle={() => {
            if (batchModelOpen) {
              setBatchData([])
              setProductTax([])
            }
            setBatchModelOpen(!batchModelOpen)
          }}
          itemList={batchData}
          itemTax={productTax}
          SetDataToDetTable={SetDataToDetTable}
        />
        <Row className="mb-0">
          <Col md="12" id={"txtID" + Key}>
            {indexOfFirstPost + Key + 1}
          </Col>
        </Row>
      </td>
      <td style={{ width: parseInt(procode.width) }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              ref={proCodeRef}
              rowClass="mb-12-sm"
              labelText=""
              textType="text"
              maxLength={procode.len}
              id={procode.name + Key}
              value={FormRow.strDET_PROCODE}
              disabled={DisableDet ? true : txn.intTX_BOM == 1 ? true : FormRow.disable}
              onChange={e => {
                let txt = Text(e.target, 25, true, true, "upper", false)
                changeRowValueChanges(txt, FormRow.id, "strDET_PROCODE")
              }}
              onBlur={(e) => {
                KeyPressEvnt(e, Key, 13)

              }}
              onKeyPress={e => {
                KeyPressEvnt(e, Key)
              }}
              backgroundColor={txn.intTX_SHOW_GP_DIFFERENCE == 1 && currentRowGP != 0 ? true : baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
              color={txn.intTX_SHOW_GP_DIFFERENCE == 1 && currentRowGP != 0 ? gpColor : baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      {txn.intTX_BOM == 0 ? (
        <td style={{ width: "20px" }}>
          <Row className="mb-0">
            <Col md="12">
              <Button
                outline
                color="success"
                disabled={DisableDet ? true : FormRow.disable}
                id={"btnSearch" + Key}
                onClick={clickSearch}
                size="sm"

              >
                <i
                  className="mdi mdi-search-web"
                  style={{ fontSize: "12px" }}
                ></i>
              </Button>
            </Col>
          </Row>
        </td>) : null}
      {txn.intTX_STOCKCODE == 1 ? (
        <td style={{ width: parseInt(stkcode.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={stkcode.len}
                id={stkcode.name + Key}
                value={FormRow.strDET_STOCKCODE}
                disabled={DisableDet ? true : true}
                onChange={e => {
                  let txt = Text(e.target, 25, true, false, "upper", false)
                  changeRowValueChanges(txt, FormRow.id, "strDET_STOCKCODE")
                }}
                onKeyPress={e => {
                  KeyPressEvnt(e, Key)
                }}
                backgroundColor={txn.intTX_SHOW_GP_DIFFERENCE == 1 && currentRowGP != 0 ? true : baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={txn.intTX_SHOW_GP_DIFFERENCE == 1 && currentRowGP != 0 ? gpColor : baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
                titleEnable={true}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      <td style={{ width: parseInt(prodesc.width) }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText=""
              textType="text"
              maxLength={prodesc.len}
              id={prodesc.name + Key}
              value={FormRow.strDET_PRODESC}
              //disabled={txn.intTX_BOM == 1 ? true : true}
              disabled={DisableDet == false && FormRow.openItem == 1 ? false : true}
              onChange={e => {
                let txt = Text(e.target, 50, true, true, "upper", true)
                changeRowValueChanges(txt, FormRow.id, "strDET_PRODESC")
                //setdesc(txt)
              }}
              onKeyPress={e => {
                KeyPressEvnt(e, Key)
              }}
              backgroundColor={txn.intTX_SHOW_GP_DIFFERENCE == 1 && currentRowGP != 0 ? true : baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
              color={txn.intTX_SHOW_GP_DIFFERENCE == 1 && currentRowGP != 0 ? gpColor : baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              titleEnable={true}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: parseInt(prounit.width) }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText=""
              textType="text"
              maxLength={prounit.len}
              id={prounit.name + Key}
              value={FormRow.strDET_UNIT}
              disabled={true}
              onChange={e => {
                let txt = Numeric(e.target, quantityEnterNoCount, txnDecimalQty, false)
                changeRowValueChanges(txt, FormRow.id, "strDET_UNIT")
                //setunit(txt)
              }}
              /*onKeyPress={e => {
                            KeyPressEvnt(e)
                        }}*/
              backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
              color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      {txn.intTX_SHOWCS != 0 ? (
        <td style={{ width: parseInt(procs.width) }}>
          <Row className="mb-0">
            <Col md="12">
              {txn.intTX_ENABLE_INNERCS == 0 ? <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                textAlign={"right"}
                maxLength={procs.len}
                id={procs.name + Key}
                value={FormRow.dcDET_CS}
                disabled={true}
                onChange={e => {
                  let txt = Numeric(e.target, quantityEnterNoCount, txnDecimalQty, false)
                  //changeRowValueChanges(txt, FormRow.id, "dcDET_CS")

                  let currentRow = FormRow

                  currentRow.dcDET_CPRICE = (parseFloat(currentRow.dcDET_CPRICE) / parseFloat(currentRow.dcDET_CS)) * parseFloat(txt)
                  currentRow.dcDET_CS = txt

                  handleObjectChange(currentRow, FormRow.id)


                }}
                onKeyPress={e => {
                  KeyPressEvnt(e, Key)
                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              /> :
                <DPDropDown
                  rowClass="mb-4-sm"
                  labelText=""
                  id={procs.name + Key}
                  optionGroup={FormRow.innerCS}
                  selectedGroup={FormRow.dcDET_CS}
                  disabled={DisableDet}
                  onChange={e => {

                    let txt = e["value"]
                    let currentRow = FormRow

                    //currentRow.dcDET_CPRICE = (parseFloat(currentRow.dcDET_CPRICE) / parseFloat(currentRow.dcDET_CS)) * parseFloat(txt)

                    currentRow.dcDET_CPRICE = (parseFloat(currentRow.dcDET_CPRICE_OLD) / parseFloat(currentRow.defaultCS)) * parseFloat(txt)
                    currentRow.dcDET_ACOST = (parseFloat(currentRow.dcDET_ACOST_OLD) / parseFloat(currentRow.defaultCS)) * parseFloat(txt)

                    currentRow.dcDET_CS = txt

                    handleObjectChange(currentRow, FormRow.id)
                  }
                  }
                  inputId={procs.name + Key}
                  labelHide={true}
                />}

            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_SHOWSIH != 0 ? (
        <td style={{ width: parseInt(prosih.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                textAlign={"right"}
                maxLength={prosih.len}
                id={prosih.name + Key}
                value={FormRow.dcDET_SYSQTY}
                disabled={true}
                onChange={e => {
                  let txt = Numeric(e.target, quantityEnterNoCount, txnDecimalQty, false)
                  changeRowValueChanges(txt, FormRow.id, "dcDET_SYSQTY")
                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              />
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_SHOWSIH != 0 ? (
        <td style={{ width: "20px" }}>
          <Row className="mb-0">
            <Col md="12">
              <Button
                outline
                color="primary"
                disabled={DisableDet}
                id={"btnSearch" + Key}
                onClick={() => viewAllLocationSOH(FormRow.strDET_PROCODE, FormRow.strDET_STOCKCODE)}
                size="sm"
                title="View SOH "
              >
                <i
                  className="mdi mdi-eye"
                  style={{ fontSize: "12px" }}
                ></i>
              </Button>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_SHOWVAR == 1 || txn.intTX_BOM == 1 ? (
        <td style={{ width: parseInt(provar.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                textAlign={"right"}
                maxLength={provar.len}
                id={provar.name + Key}
                value={FormRow.dcDET_VARQTY}
                disabled={true}
                onChange={e => {
                  let txt = Numeric(e.target, quantityEnterNoCount, txnDecimalQty, false)
                  changeRowValueChanges(txt, FormRow.id, "dcDET_VARQTY")
                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_SHOWGP == 1 ? (
        <td style={{ width: "20px" }}>
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText=""
            textType="text"
            textAlign={"right"}
            maxLength={""}
            id={"GPFix" + Key}
            value={FormRow.fixGP}
            disabled={true}
            backgroundColor={txn.intTX_VALIDATE_GP_VARIANCE == 1 && parseFloat(FormRow.fixGP) != parseFloat(CalculateCurrentGP(FormRow.dcDET_SPRICE, FormRow.dcDET_CPRICE, FormRow.dcDET_CS)) && FormRow.strDET_STOCKCODE != "" ? true : false}
            color={txn.intTX_VALIDATE_GP_VARIANCE == 1 && parseFloat(FormRow.fixGP) != parseFloat(CalculateCurrentGP(FormRow.dcDET_SPRICE, FormRow.dcDET_CPRICE, FormRow.dcDET_CS)) && FormRow.strDET_STOCKCODE != "" ? "#FEED30" : ""}
          />
        </td>) : null}
      {txn.intTX_SHOWGP == 1 ? (
        <td style={{ width: "20px" }}>
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText=""
            textType="text"
            textAlign={"right"}
            maxLength={""}
            id={"GPCurrent" + Key}
            value={parseFloat(CalculateCurrentGP(FormRow.dcDET_SPRICE, FormRow.dcDET_CPRICE, FormRow.dcDET_CS))}
            disabled={true}
            backgroundColor={txn.intTX_VALIDATE_GP_VARIANCE == 1 && parseFloat(FormRow.fixGP) != parseFloat(CalculateCurrentGP(FormRow.dcDET_SPRICE, FormRow.dcDET_CPRICE, FormRow.dcDET_CS)) && FormRow.strDET_STOCKCODE != "" ? true : false}
            color={txn.intTX_VALIDATE_GP_VARIANCE == 1 && parseFloat(FormRow.fixGP) != parseFloat(CalculateCurrentGP(FormRow.dcDET_SPRICE, FormRow.dcDET_CPRICE, FormRow.dcDET_CS)) && FormRow.strDET_STOCKCODE != "" ? "#FEED30" : ""}
          />
        </td>) : null}
      {txn.intTX_EXPCHKSIH == 1 ? (
        <td style={{ maxWidth: parseInt(proexpdate.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="date"
                maxLength={proexpdate.len}
                id={proexpdate.name + Key}
                value={FormRow.dtDET_EXPDAET != undefined
                  ? FormRow.dtDET_EXPDAET.slice(0, 10) == "1900-01-01"
                    ? ""
                    : FormRow.dtDET_EXPDAET.substring(0, 10)
                  : ""}
                disabled={DisableDet ? true : FormRow.dtDET_EXPCHECK == 1 && txn.intTX_IS_BATCH_TXN == 0 && txn.intTX_CREATE_BATCH == 1 ? false : true}
                onChange={e => {
                  changeRowValueChanges(e.target.value, FormRow.id, "dtDET_EXPDAET")
                }}
                onKeyPress={e => {
                  KeyPressEvnt(e, Key)
                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      <td
        style={{
          width: parseInt(procost.width),
          visibility: parseInt(procost.width) > 0 ?
            txn.strTX_PRICEMODE == "C" || txn.strTX_SHOWPRICE == "C"
              ? "visible"
              : "hidden" : "hidden",
          display: parseInt(procost.width) > 0 ?
            txn.strTX_PRICEMODE == "C" || txn.strTX_SHOWPRICE == "C"
              ? "table-cell"
              : "none" : "none",
        }}
      >
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText=""
              textType="text"
              maxLength={procost.len}
              id={procost.name + Key}
              value={FormRow.dcDET_CPRICE}
              visibility={
                txn.strTX_PRICEMODE == "C" || txn.strTX_SHOWPRICE == "C"
                  ? "visible"
                  : "hidden"
              }
              //disabled={DisableDet == true ? true : txn.intTX_BOM == 1 ? true : txn.intTX_CHANGEPRICE == 0 ? true : FormRow.openItem == 1 ? false : true}
              disabled={DisableDet == false && FormRow.openItem == 1 ? false : DisableDet == false && txn.intTX_CHANGEPRICE == 1 ? false : true}
              textAlign={"right"}
              onChange={e => {
                let txt = Numeric(e.target, priceEnterNoCount, txnDecimalAmt, false)
                if (e.target.value == "") {
                  txt = 0
                }
                changeRowValueChanges(txt, FormRow.id, "dcDET_CPRICE")
              }}
              onKeyPress={e => {
                if (e.key == "Enter") {
                  KeyPressEvnt(e, Key)
                }
              }}
              onBlur={async (e) => {
                let costPrice = parseFloat(e.target.value).toFixed(txnDecimalAmt)
                costPrice = DecimalValidation(costPrice, 0, true, txnDecimalAmt)
                LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, FormRow.dcDET_DISCPER, FormRow.dcDET_DISCAMT, FormRow.dcDET_FUNITQTY, costPrice, FormRow.dcDET_SPRICE)
              }}
              backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
              color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td
        style={{
          width: parseInt(prosell.width),
          visibility: parseInt(prosell.width) > 0 ? txn.strTX_PRICEMODE == "S" || txn.strTX_SHOWPRICE == "S" ? "visible" : "hidden" : "hidden",
          display: parseInt(prosell.width) > 0 ?
            txn.strTX_PRICEMODE == "S" || txn.strTX_SHOWPRICE == "S"
              ? "table-cell"
              : "none" : "none",
        }}
      >
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText=""
              textType="text"
              maxLength={prosell.len}
              id={prosell.name + Key}
              value={FormRow.dcDET_SPRICE}
              visibility={
                txn.strTX_PRICEMODE == "S" || txn.strTX_SHOWPRICE == "S"
                  ? "visible"
                  : "hidden"
              }
              textAlign={"right"}
              disabled={DisableDet == false && FormRow.openItem == 1 ? false : DisableDet == false && txn.intTX_CHANGEPRICE == 1 ? false : true}
              onChange={e => {
                let txt = Numeric(e.target, priceEnterNoCount, txnDecimalAmt, false)
                if (e.target.value == "") {
                  txt = 0
                }
                changeRowValueChanges(txt, FormRow.id, "dcDET_SPRICE")
              }}
              onKeyPress={e => {
                if (e.key == "Enter") {
                  KeyPressEvnt(e, Key)
                }
              }}
              onBlur={async (e) => {
                let sellingPrice = parseFloat(e.target.value).toFixed(txnDecimalAmt)
                sellingPrice = DecimalValidation(sellingPrice, 0, true, txnDecimalAmt)

                if ((parseFloat(FormRow.dcDET_CPRICE) / parseFloat(FormRow.dcDET_CS)) > parseFloat(sellingPrice)) {
                  setDetailAlertShow(true)
                  setDetailAlertConfirmOption(101)
                  setDetailPermissionAlertTitle("Under Cost! Selling price is lower than Cost prive ?")
                  setDetailPermissionMenuCode("P00300")
                }

                LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, FormRow.dcDET_DISCPER, FormRow.dcDET_DISCAMT, FormRow.dcDET_FUNITQTY, FormRow.dcDET_CPRICE, sellingPrice)
              }}
              backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
              color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td
        style={{
          width: parseInt(proweightavg.width),
          visibility: parseInt(proweightavg.width) > 0 ?
            String(txn.strTX_PRICEMODE).toLowerCase() == "a" || String(txn.strTX_SHOWPRICE).toLowerCase() == "a"
              ? "visible"
              : "hidden" : "hidden",
          display: parseInt(proweightavg.width) > 0 ?
            String(txn.strTX_PRICEMODE).toLowerCase() == "a" || String(txn.strTX_SHOWPRICE).toLowerCase() == "a"
              ? "table-cell"
              : "none" : "none",
        }}
      >
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText=""
              textType="text"
              maxLength={proweightavg.len}
              id={proweightavg.name + Key}
              visibility={
                String(txn.strTX_PRICEMODE).toLowerCase() == "a" || String(txn.strTX_SHOWPRICE).toLowerCase() == "a"
                  ? "visible"
                  : "hidden"
              }
              value={parseFloat(FormRow.dcDET_ACOST).toFixed(txnDecimalAmt)}
              textAlign={"right"}
              disabled={true}
              onChange={e => {
                let txt = Numeric(e.target, priceEnterNoCount, txnDecimalAmt, false)
                changeRowValueChanges(txt, FormRow.id, "dcDET_ACOST")
              }}
              onKeyPress={e => {
                KeyPressEvnt(e, Key)
              }}
              backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
              color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td
        style={{
          width: parseInt(propackprice.width),
          visibility: parseInt(propackprice.width) > 0 ?
            String(txn.strTX_PRICEMODE).toLowerCase() == "p" || String(txn.strTX_SHOWPRICE).toLowerCase() == "p"
              ? "visible"
              : "hidden" : "hidden",
          display: parseInt(propackprice.width) > 0 ?
            String(txn.strTX_PRICEMODE).toLowerCase() == "p" || String(txn.strTX_SHOWPRICE).toLowerCase() == "p"
              ? "table-cell"
              : "none" : "none",
        }}
      >
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText=""
              textType="text"
              maxLength={propackprice.len}
              id={propackprice.name + Key}
              visibility={
                txn.strTX_PRICEMODE == "P" || txn.strTX_SHOWPRICE == "P"
                  ? "visible"
                  : "hidden"
              }
              value={parseFloat(FormRow.dbPackPrice).toFixed(txnDecimalAmt)}
              textAlign={"right"}
              disabled={txn.intTX_CHANGEPRICE == 0}
              onChange={e => {
                let txt = Numeric(e.target, priceEnterNoCount, txnDecimalAmt, false)
                changeRowValueChanges(txt, FormRow.id, "dbPackPrice")
              }}
              onKeyPress={e => {
                KeyPressEvnt(e, Key)
              }}
              backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
              color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>

      {txn.intTX_SHOW_BALQTY == 1 ? (
        <td style={{ width: parseInt(probalqty.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={probalqty.len}
                id={probalqty.name + Key}
                value={parseFloat(FormRow.dcDET_BALQTY).toFixed(txnDecimalQty)}
                textAlign={"right"}
                disabled={true} //balqtyDisable}
                onChange={e => {
                  let txt = 0
                  if (FormRow.isDecimal == 1) {
                    txt = Numeric(e.target, quantityEnterNoCount, txnDecimalQty, false)
                  } else {
                    txt = Numeric(e.target, quantityEnterNoCount, 0, false)
                  }
                  changeRowValueChanges(txt, FormRow.id, "dcDET_BALQTY")
                }}
                onBlur={e => {

                  LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, FormRow.dcDET_DISCPER, FormRow.dcDET_DISCAMT, FormRow.dcDET_FUNITQTY)
                }}
                /*onKeyPress={e => {
                            KeyPressEvnt(e)
                        }}*/
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_SHOW_FBALQTY == 1 ? (
        <td style={{ width: parseInt(probalqty.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={probalqty.len}
                id={probalqty.name + Key}
                value={parseFloat(FormRow.dcDET_FBALQTY).toFixed(txnDecimalQty)}
                textAlign={"right"}
                disabled={true} //balqtyDisable}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_CASEQTY == 1 ? (
        <td style={{ width: parseInt(procaseqty.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={procaseqty.len}
                id={procaseqty.name + Key}
                value={FormRow.dcDET_CASEQTY}
                textAlign={"right"}
                disabled={txn.intTX_DISABLEQTY == 1 ? true : DisableDet}
                onChange={e => {
                  let txt = 0
                  if (FormRow.isDecimal == 1) {
                    txt = Numeric(e.target, quantityEnterNoCount, 0, txn.intTX_ALLOWMINUS == 1 ? true : false)
                  } else {
                    txt = Numeric(e.target, quantityEnterNoCount, 0, txn.intTX_ALLOWMINUS == 1 ? true : false)
                  }

                  changeRowValueChanges(txt, FormRow.id, "dcDET_CASEQTY")

                }}
                onBlur={async (e) => {

                  let caseQty = e.target.value
                  caseQty = DecimalValidation(caseQty, 0, true, 0)

                  var newRow = FormRow

                  if (caseQty.length <= 0) {
                    newRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)
                  } else {
                    if (FormRow.isDecimal == 1) { //if decimal is enabled then set the unit qty to decimal
                      newRow.dcDET_CASEQTY = parseFloat(caseQty).toFixed(0)
                      caseQty = parseFloat(caseQty).toFixed(0)
                    } else {
                      newRow.dcDET_CASEQTY = parseFloat(caseQty).toFixed(0)
                      caseQty = parseFloat(caseQty).toFixed(0)
                    }
                  }

                  if (caseQty == "") {
                    newRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)
                    caseQty = parseFloat(0).toFixed(0)
                  }

                  if (caseQty == 0 && parseFloat(FormRow.dcDET_UNITQTY) == 0) {
                    newRow.dcDET_DISCPER = parseFloat(0).toFixed(txnDecimalAmt)
                    newRow.dcDET_DISCAMT = parseFloat(0).toFixed(txnDecimalAmt)
                  }

                  let qty = parseFloat(FormRow.dcDET_UNITQTY) + (parseFloat(FormRow.dcDET_CS) * parseFloat(caseQty))

                  if (txn.strTX_SOURCEINV == "-" && txn.intTX_CHKSIH == 1 && parseFloat(FormRow.dcDET_SYSQTY) < parseFloat(qty)) {

                    setDetailPermissionAlertTitle("Quantity exceed the stock in hand quantity for the item " + FormRow.strDET_PROCODE + " !")
                    setDetailAlertConfirmOption(97)
                    setDetailAlertShow(true)
                    setDetailPermissionMenuCode("P00126")
                    return
                  }

                  if (parseFloat(txn.dcTX_QTY_INCREASE_PERCENTAGE) != 0 && (parseFloat(FormRow.dcDET_BALQTY) > 0 && (parseFloat(qty) > (parseFloat(FormRow.dcDET_BALQTY) * (100 + parseFloat(txn.dcTX_QTY_INCREASE_PERCENTAGE)) / 100)))) {

                    setDetailPermissionAlertTitle("Quantity exceed the allowed limit for the item " + FormRow.strDET_STOCKCODE + " !")
                    setDetailAlertConfirmOption(96)
                    setDetailAlertShow(true)
                    setDetailPermissionMenuCode(MENUPERMISSION_QTY_EXCEED)


                  }

                  if (txn.intTX_SHOWPRICEMODE == 1 && priceModeSelect != "") { //if price mode is enabled then get the price according to the price mode

                    var proPrice = await getTxnProductPricemode(FormRow.strDET_PROCODE, FormRow.strDET_STOCKCODE, loccode, priceModeSelect, qty, txn.strTX_TYPE) //get product price according to the payment mode

                    if (proPrice.status == 1) {
                      //if product price is available then set the price
                      newRow.dcDET_SPRICE = parseFloat(proPrice.price) == 0 ? parseFloat(FormRow.dcDET_SPRICE_OLD).toFixed(txnDecimalAmt) : parseFloat(proPrice.price).toFixed(txnDecimalAmt)
                      // newRow.dcDET_DISCAMT = parseFloat(proPrice.discAmt).toFixed(txnDecimalAmt)
                      // newRow.dcDET_DISCPER = parseFloat(proPrice.discPer).toFixed(2)

                      // Check if both discAmt and discPer are greater than 0, set discAmt to 0 if so
                      if (parseFloat(proPrice.discAmt) > 0 && parseFloat(proPrice.discPer) > 0) {
                        newRow.dcDET_DISCAMT = "0.00"; // Set discAmt to 0 if both are greater than 0
                        newRow.dcDET_DISCPER = parseFloat(proPrice.discPer).toFixed(2);
                      } else {
                        // Set the appropriate value based on the availability of discAmt or discPer
                        newRow.dcDET_DISCAMT = parseFloat(proPrice.discAmt) > 0
                          ? parseFloat(proPrice.discAmt).toFixed(txnDecimalAmt)
                          : "0.00";
                        newRow.dcDET_DISCPER = parseFloat(proPrice.discPer) > 0
                          ? parseFloat(proPrice.discPer).toFixed(2)
                          : "0.00";
                      }

                    } else {
                      //if product price is not available then set the old price
                      newRow.dcDET_SPRICE = FormRow.dcDET_SPRICE_OLD
                    }
                  }


                  //add free qty based on the supplier selected in the grid
                  if (txn.intTX_ENABLE_SUPFREEQTY == 1 && supplierSelect != "" && FormRow.strDET_STOCKCODE != "") {

                    const supplierFreeQty = await ValidateFreeQty(FormRow.strDET_PROCODE, supplierSelect, qty)

                    if (txn.intTX_FREECASEQTY == 1 && txn.intTX_FREEUNITQTY == 1) {
                      newRow.dcDET_FCASEQTY = Math.floor(parseFloat(supplierFreeQty) / parseFloat(FormRow.dcDET_CS)) //set the free case qty to the free unit qty
                      newRow.dcDET_FUNITQTY = parseFloat(supplierFreeQty) % parseFloat(FormRow.dcDET_CS)
                    }
                    else if (txn.intTX_FREECASEQTY == 1) {
                      newRow.dcDET_FUNITQTY = Math.floor(parseFloat(supplierFreeQty) / parseFloat(FormRow.dcDET_CS)) //set the free case qty to the free unit qtyෆ
                    }
                    else if (txn.intTX_FREEUNITQTY == 1) {
                      newRow.dcDET_FUNITQTY = supplierFreeQty
                    }

                  }


                  handleObjectChange(newRow, FormRow.id) //set new values to the row object

                  setTimeout(async () => {
                    await CheckBalQty(1, caseQty, FormRow.dcDET_UNITQTY)
                    LineAmtCalcualtion(FormRow.dcDET_UNITQTY, caseQty, newRow.dcDET_DISCPER, newRow.dcDET_DISCAMT, FormRow.dcDET_FUNITQTY)////

                  }, 100)
                }}
                onKeyPress={e => {
                  if (e.key == "Enter") {
                    KeyPressEvnt(e, Key)
                  }
                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_UNITQTY == 1 ? (
        <td style={{ width: parseInt(prouniteqty.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={prouniteqty.len}
                id={prouniteqty.name + Key}
                textAlign={"right"}
                value={FormRow.dcDET_UNITQTY}
                disabled={DisableDet ? true : txn.intTX_BOM == 1 ? true : txn.intTX_DISABLEQTY == 1 ? true : DisableDet}
                onChange={e => {
                  let txt = 0
                  if (FormRow.isDecimal == 1) {
                    txt = Numeric(e.target, quantityEnterNoCount, txnDecimalQty, txn.intTX_ALLOWMINUS == 1 ? true : false)
                  } else {
                    txt = Numeric(e.target, quantityEnterNoCount, 0, txn.intTX_ALLOWMINUS == 1 ? true : false)
                  }

                  changeRowValueChanges(txt, FormRow.id, "dcDET_UNITQTY")

                }}
                onBlur={async (e) => {

                  if (txn.intTX_BOM == 1) {

                  } else {
                    let unit = e.target.value
                    unit = DecimalValidation(unit, 0, FormRow.isDecimal == 1 ? true : false, txnDecimalQty)

                    var newRow = FormRow

                    let qty = parseFloat(unit) + (parseFloat(FormRow.dcDET_CS) * parseFloat(FormRow.dcDET_CASEQTY))

                    if (txn.strTX_SOURCEINV == "-" && txn.intTX_CHKSIH == 1 && parseFloat(FormRow.dcDET_SYSQTY) < parseFloat(qty)) {

                      setDetailPermissionAlertTitle("Quantity exceed the stock in hand quantity for the item " + FormRow.strDET_PROCODE + " !")
                      setDetailAlertConfirmOption(97)
                      setDetailAlertShow(true)
                      setDetailPermissionMenuCode("P00126")

                      return
                      
                    }


                    if (parseFloat(txn.dcTX_QTY_INCREASE_PERCENTAGE) != 0 && (parseFloat(FormRow.dcDET_BALQTY) > 0 && (parseFloat(qty) > (parseFloat(FormRow.dcDET_BALQTY) * (100 + parseFloat(txn.dcTX_QTY_INCREASE_PERCENTAGE)) / 100)))) {

                      setDetailPermissionAlertTitle("Quantity exceed the allowed limit for the item " + FormRow.strDET_STOCKCODE + " !")
                      setDetailAlertConfirmOption(96)
                      setDetailAlertShow(true)
                      setDetailPermissionMenuCode(MENUPERMISSION_QTY_EXCEED)

                    }


                    if (txn.intTX_SHOWPRICEMODE == 1 && priceModeSelect != "") { //if price mode is enabled then get the price according to the price mode

                      var proPrice = await getTxnProductPricemode(FormRow.strDET_PROCODE, FormRow.strDET_STOCKCODE, loccode, priceModeSelect, qty, txn.strTX_TYPE) //get product price according to the payment mode

                      if (proPrice.status == 1) {              //if product price is available then set the price
                        newRow.dcDET_SPRICE = parseFloat(proPrice.price) == 0 ? parseFloat(FormRow.dcDET_SPRICE_OLD).toFixed(txnDecimalAmt) : parseFloat(proPrice.price).toFixed(txnDecimalAmt)
                        // newRow.dcDET_DISCAMT = parseFloat(proPrice.discAmt).toFixed(txnDecimalAmt)
                        // newRow.dcDET_DISCPER = parseFloat(proPrice.discPer).toFixed(2)

                        // Check if both discAmt and discPer are greater than 0, set discAmt to 0 if so
                        if (parseFloat(proPrice.discAmt) > 0 && parseFloat(proPrice.discPer) > 0) {
                          newRow.dcDET_DISCAMT = "0.00"; // Set discAmt to 0 if both are greater than 0
                          newRow.dcDET_DISCPER = parseFloat(proPrice.discPer).toFixed(2);
                        } else {
                          // Set the appropriate value based on the availability of discAmt or discPer
                          newRow.dcDET_DISCAMT = parseFloat(proPrice.discAmt) > 0
                            ? parseFloat(proPrice.discAmt).toFixed(txnDecimalAmt)
                            : "0.00";
                          newRow.dcDET_DISCPER = parseFloat(proPrice.discPer) > 0
                            ? parseFloat(proPrice.discPer).toFixed(2)
                            : "0.00";
                        }


                      } else { //if product price is not available then set the old price
                        newRow.dcDET_SPRICE = FormRow.dcDET_SPRICE_OLD
                      }
                    }

                    if (unit.length <= 0) { //if unit qyt is empty then set the unit qty to zero
                      newRow.dcDET_UNITQTY = parseFloat(0).toFixed(txnDecimalQty)
                    } else {
                      if (FormRow.isDecimal == 1) { //if decimal is enabled then set the unit qty to decimal
                        newRow.dcDET_UNITQTY = parseFloat(unit).toFixed(txnDecimalQty)
                      } else {
                        newRow.dcDET_UNITQTY = parseFloat(unit).toFixed(0)
                      }
                    }

                    //if unit qyt is zero then set the discount percentage and discount amount to zero
                    if (unit == 0 && parseFloat(FormRow.dcDET_CASEQTY) == 0) {
                      newRow.dcDET_DISCPER = parseFloat(0).toFixed(txnDecimalAmt)
                      newRow.dcDET_DISCAMT = parseFloat(0).toFixed(txnDecimalAmt)
                    }

                    if (txn.intTX_SHOWVAR == 1) {
                      newRow.dcDET_VARQTY = (parseFloat(newRow.dcDET_UNITQTY) - parseFloat(newRow.dcDET_SYSQTY))
                    }


                    //add free qty based on the supplier selected in the grid
                    if (txn.intTX_ENABLE_SUPFREEQTY == 1 && supplierSelect != "" && FormRow.strDET_STOCKCODE != "") {

                      const supplierFreeQty = await ValidateFreeQty(FormRow.strDET_PROCODE, supplierSelect, qty)

                      if (txn.intTX_FREECASEQTY == 1 && txn.intTX_FREEUNITQTY == 1) {
                        newRow.dcDET_FCASEQTY = Math.floor(parseFloat(supplierFreeQty) / parseFloat(FormRow.dcDET_CS)) //set the free case qty to the free unit qty
                        newRow.dcDET_FUNITQTY = parseFloat(supplierFreeQty) % parseFloat(FormRow.dcDET_CS)
                      }
                      else if (txn.intTX_FREECASEQTY == 1) {
                        newRow.dcDET_FUNITQTY = Math.floor(parseFloat(supplierFreeQty) / parseFloat(FormRow.dcDET_CS)) //set the free case qty to the free unit qtyෆ
                      }
                      else if (txn.intTX_FREEUNITQTY == 1) {
                        newRow.dcDET_FUNITQTY = supplierFreeQty
                      }

                    }

                    handleObjectChange(newRow, FormRow.id) //set new values to the row object

                    setTimeout(async () => {
                      await CheckBalQty(2, FormRow.dcDET_CASEQTY, unit)

                      LineAmtCalcualtion(unit, FormRow.dcDET_CASEQTY, newRow.dcDET_DISCPER, newRow.dcDET_DISCAMT, FormRow.dcDET_FUNITQTY)
                    }, 100)
                  }
                }
                }
                onKeyPress={e => {
                  if (txn.intTX_BOM == 1) {
                    // calculateBomUnit()
                  } else {
                    KeyPressEvnt(e, Key)
                  }

                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_FREEUNITQTY == 1 ? (
        <td style={{ width: parseInt(profreeunit.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={profreeunit.len}
                id={profreeunit.name + Key}
                textAlign={"right"}
                value={FormRow.dcDET_FUNITQTY}
                disabled={DisableDet ? true : txn.intTX_BOM == 1 && baseProduct && baseProduct == FormRow.strDET_PROCODE ? false : txn.intTX_BOM == 1 && baseProduct && baseProduct != FormRow.strDET_PROCODE ? true : txn.intTX_BOM == 1 && baseProduct == "" ? true : false}
                onChange={e => {
                  let txt = 0
                  if (FormRow.isDecimal == 1 || txn.intTX_BOM == 1) {
                    txt = Numeric(e.target, quantityEnterNoCount, txnDecimalQty, txn.intTX_ALLOWMINUS == 1 ? true : false)
                  } else {
                    txt = Numeric(e.target, quantityEnterNoCount, 0, txn.intTX_ALLOWMINUS == 1 ? true : false)
                  }

                  if (txt == "") {
                    txt = 0
                  }

                  changeRowValueChanges(txt, FormRow.id, "dcDET_FUNITQTY")

                }}
                onKeyPress={async (e) => {
                  KeyPressEvnt(e, Key)
                }}
                onBlur={async (e) => {

                  let freeUnit = e.target.value
                  freeUnit = DecimalValidation(freeUnit, 0, FormRow.isDecimal == 1 ? true : false, txnDecimalQty)


                  const isSuccess = await LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, FormRow.dcDET_DISCPER, FormRow.dcDET_DISCAMT, freeUnit)

                  if (txn.intTX_BOM == 1 && isSuccess) {
                    calculateBomUnit()
                  }

                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? DisableDet ? true : false : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_FREECASEQTY == 1 ? (
        <td style={{ width: parseInt(profreecase.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={profreecase.len}
                id={profreecase.name + Key}
                textAlign={"right"}
                value={FormRow.dcDET_FCASEQTY}
                disabled={DisableDet ? true : txn.intTX_BOM == 1 ? false : DisableDet}
                onBlur={async e => {
                  var newRow = FormRow

                  let isDecimalForFreeCase = (txn.intTX_VERIFICATION == 1 || txn.intTX_PRODUCTION == 1 || txn.intTX_BOM == 1) && FormRow.isDecimal == 1;

                  isDecimalForFreeCase = txn.intTX_BOM == 1 ? true : isDecimalForFreeCase

                  if (e.target.value == "" || e.target.value == null) {
                    newRow.dcDET_FCASEQTY = isDecimalForFreeCase ? parseFloat(0).toFixed(txnDecimalQty) : parseFloat(0).toFixed(0)
                    await handleObjectChange(newRow, FormRow.id) //set new values to the row object
                  }

                  const isSuccess = await LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, FormRow.dcDET_DISCPER, FormRow.dcDET_DISCAMT, FormRow.dcDET_FUNITQTY)

                  if (txn.intTX_BOM == 1 && proSelect != "" && proSelect == FormRow.strDET_PROCODE && isSuccess) {
                    calculateBomUnit()
                  }

                }}
                onChange={e => {
                  let txt = 0
                  let isDecimalForFreeCase = (txn.intTX_VERIFICATION == 1 || txn.intTX_PRODUCTION == 1 || txn.intTX_BOM == 1) && FormRow.isDecimal == 1;
                  isDecimalForFreeCase = txn.intTX_BOM == 1 ? true : isDecimalForFreeCase
                  if (isDecimalForFreeCase) {
                    txt = Numeric(e.target, quantityEnterNoCount, txnDecimalQty, txn.intTX_ALLOWMINUS == 1 ? true : false)
                  } else {
                    txt = Numeric(e.target, quantityEnterNoCount, 0, txn.intTX_ALLOWMINUS == 1 ? true : false)
                  }


                  changeRowValueChanges(txt, FormRow.id, "dcDET_FCASEQTY")

                }}
                onKeyPress={e => {
                  KeyPressEvnt(e, Key)
                  if (txn.intTX_BOM == 1 && proSelect != "" && proSelect == FormRow.strDET_PROCODE) {
                    calculateBomUnit()
                  }
                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? false : proSelect && proSelect == FormRow.strDET_PROCODE ? false : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_LINEDISCPER == 1 ? (
        <td style={{ width: parseInt(prodiscper.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={prodiscper.len}
                id={prodiscper.name + Key}
                textAlign={"right"}
                value={FormRow.dcDET_DISCPER}
                disabled={DisableDet}
                onChange={e => {
                  let txt = Numeric(e.target, priceEnterNoCount, txnDecimalAmt, false)
                  if (parseFloat(txt) <= 100) {
                    changeRowValueChanges(txt, FormRow.id, "dcDET_DISCPER")
                  } else if (e.target.value == "") {
                    changeRowValueChanges(parseFloat(0).toFixed(txnDecimalAmt), FormRow.id, "dcDET_DISCPER")
                  }
                }}
                onBlur={e => {
                  changeRowValueChanges(parseFloat(e.target.value).toFixed(txnDecimalAmt), FormRow.id, "dcDET_DISCPER")
                  LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, e.target.value, FormRow.dcDET_DISCAMT, FormRow.dcDET_FUNITQTY)
                }}
                onKeyPress={e => {
                  KeyPressEvnt(e, Key)
                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_LINEDISCAMT == 1 ? (
        <td style={{ width: parseInt(prodiscamt.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={prodiscamt.len}
                id={prodiscamt.name + Key}
                textAlign={"right"}
                value={FormRow.dcDET_DISCAMT}
                disabled={DisableDet}
                onChange={e => {
                  let txt = Numeric(e.target, priceEnterNoCount, txnDecimalAmt, false)
                  if (txt == "") {
                    txt = 0
                  }
                  changeRowValueChanges(txt, FormRow.id, "dcDET_DISCAMT")
                  //setdiscAmt(txt)
                }}
                onBlur={e => {
                  if (e.target.value == "") {
                    changeRowValueChanges(parseFloat(0).toFixed(txnDecimalAmt), FormRow.id, "dcDET_DISCAMT")
                  } else {
                    changeRowValueChanges(parseFloat(e.target.value).toFixed(txnDecimalAmt), FormRow.id, "dcDET_DISCAMT")
                  }

                  LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, FormRow.dcDET_DISCPER, e.target.value, FormRow.dcDET_FUNITQTY)
                }}
                onKeyPress={e => {
                  KeyPressEvnt(e, Key)
                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_HIDEPRICES == 0 ? (
        <td style={{ width: parseInt(proamt.width) }}>
          <Row className="mb-0">
            <Col md="12">
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText=""
                textType="text"
                maxLength={proamt.len}
                id={proamt.name + Key}
                textAlign={"right"}
                value={parseFloat(FormRow.dcDET_AMOUNT).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: txnDecimalAmt,
                })}
                // value={parseFloat(FormRow.dcDET_AMOUNT).toFixed(txnDecimalAmt)}
                disabled={true}
                onChange={e => {
                  let txt = Numeric(e.target, priceEnterNoCount, txnDecimalAmt, false)
                  changeRowValueChanges(txt, FormRow.id, "dcDET_AMOUNT")
                }}
                onKeyPress={e => {
                  //KeyPressEvnt(e, Key)
                }}
                backgroundColor={baseProduct && baseProduct == FormRow.strDET_PROCODE ? true : proSelect && proSelect == FormRow.strDET_PROCODE ? true : false}
                color={baseProduct && baseProduct == FormRow.strDET_PROCODE ? "antiquewhite" : proSelect && proSelect == FormRow.strDET_PROCODE ? "#96c5c7" : ""}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </td>
      ) : null}
      {txn.intTX_LINEREMARKS == 1 ? (
        <td style={{ width: parseInt(proremark.width) }}>
          <Row className="mb-0">
            <Col md="12">

              {txn.intTX_ISDETREMCODE_INPUT == 1 ?
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText=""
                  textType="text"
                  maxLength={proamt.len}
                  id={proremark.name + Key}
                  value={FormRow.strDET_REMCODE}
                  disabled={DisableDet}
                  onChange={e => {

                    const textValue = Text(e.target, 20, true, true, 'any', true)

                    changeRowValueChanges(textValue, FormRow.id, "strDET_REMCODE")
                  }}
                  onKeyPress={e => {
                    KeyPressEvnt(e, Key)
                  }}
                />
                :
                <DPDropDown
                  rowClass="mb-4-sm"
                  labelText=""
                  id={proremark.name + Key}
                  optionGroup={detailReasonTypes}
                  selectedGroup={FormRow.strDET_REMCODE}
                  disabled={DisableDet}
                  onChange={e => {
                    changeRowValueChanges(e["value"], FormRow.id, "strDET_REMCODE")

                    if (reasonForDetails == "") {
                      setDetailAlertConfirmOption(98)
                      setAlertDescription("Do you want to add this reason as default reason for all products?")
                      setsweetAlertShow(true)
                      setsweetAlertShowCancel(true)
                    } else {
                      addNewRowOnClickReason()
                    }
                  }
                  }

                  inputId={proremark.name + Key}
                  onKeyPress={e => {
                    //KeyPressEvnt(e, Key)
                  }}
                  labelHide={true}
                />}

            </Col>
          </Row>
        </td>
      ) : null}
      <td style={{ width: "30px" }}>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              disabled={Disabled}
              color="info"
              onClick={e => {
                tog_xlargeLine()
              }}
              size="sm"
            >
              <i className="mdi mdi-asterisk" style={{ fontSize: "12px" }}></i>
            </Button>
          </Col>{" "}
        </Row>
      </td>
      <td style={{ width: "30px" }}>
        <Row className="mb-0">
          <Col md="1">
            {txn.intTX_BOM == 0 ? (<Button
              outline
              color="danger"
              disabled={removeDisable ? true : txn.intTX_ITEMCHANGE == 1 ? true : DisableDet}
              onClick={async (e) => {

                setRemoveDisable(true)

                setTimeout(async () => {
                  await RemoveRow(FormRow.id)
                }, 500);

              }}
              size="sm"
            >
              <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
            </Button>) : null}
          </Col>
        </Row>
      </td>
      {txn.intTX_SHOWFILLRATE == 1 ? <td style={{ width: "30px" }}>
        <Row className="mb-0">
          <Col>
            <DPTextBoxforgrid
              value={fillRate}
              disabled={true}
            />
          </Col>
        </Row>
      </td> : null}
      <td style={{ display: 'none' }}>
        <Row className="mb-0">
          <Col>
            <DPTextBoxforgrid
              id={"Row" + Key}
              value={FormRow.id}
            />
          </Col>
        </Row>
      </td>
      {/* <td>
        {FormRow.id}
      </td> */}

      <DPMultiplePricePopUp
        isOpen={multiplePriceEnable}
        toggle={tog_multiplePrice}
        onRowClick={Row_SelectMultiplePrice}
        data={multiplePrices}
        txnDecimalAmt={txnDecimalAmt}
      />

      <DPSearchBoxDynamic
        searchData={[]}
        columns={[]}
        defaultSorted={defaultSorted}
        mainTitle={"Product Search"}
        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlarge}
        toggle={tog_xlarge}
        getSelect={Hed_SelectRowSearch}
        APIURL={window.Links.ApiURL}
        URLPath={"PRODUCT"}
        MenuCode={menuCode}
        KeyVal={"TXN"}
        searchBy={"PLU_CODE"}
        FilterStr={productSearchFilter}
      />

      <TransactionVDet
        menuName={AllPara.menuName}
        Collapse={AllPara.Collapse}
        DataRow={AllPara.DataRow}
        SetDataRow={AllPara.SetDataRow}
        InvDataRow={InvDataRow}
        TxnTotalCal={AllPara.TxnTotalCal}
        RefDataRow={AllPara.RefDataRow}
        AddRow={AllPara.AddRow}
        RemoveRow={AllPara.RemoveRow}
        BookChange={AllPara.BookChange}
        AddAmount_OnChange={AllPara.AddAmount_OnChange}
        DedAmount_OnChange={AllPara.DedAmount_OnChange}
        SupplierCode={AllPara.SupplierCode}
        blDiasableGrid={AllPara.blDiasableGrid}
        lineDisc={AllPara.lineDisc}
        SetGrossTotaltx={AllPara.SetGrossTotaltx}
        SetTxDiscount={AllPara.SetTxDiscount}
        SetLineDisc={AllPara.SetLineDisc}
        SetTxNetAmount={AllPara.SetTxNetAmount}
        GrossTotal={AllPara.GrossTotal}
        txDiscount={AllPara.txDiscount}
        txAddition={AllPara.txAddition}
        txDeduction={AllPara.txDeduction}
        txTaxInc={AllPara.txTaxInc}
        txTaxExc={AllPara.txTaxExc}
        txNetAmount={AllPara.txNetAmount}
        show={AllPara.show}
        AlertMsg={AllPara.AlertMsg}
        AlertColor={AllPara.AlertColor}
        ErrorMsg={AllPara.ErrorMsg}
        type={AllPara.type}
        txn={AllPara.txn}
        supplierSelect={AllPara.supplierSelect}
        loccode={AllPara.loccode}
        TaxDetails={AllPara.TaxDetails}
        taxTable={AllPara.taxTable}
        SetTaxtTable={AllPara.SetTaxtTable}
        DisableDet={AllPara.DisableDet}
        menuCode={AllPara.menuCode}
        setDataForRecovery={AllPara.setDataForRecovery}
        Reason={AllPara.Reason}
        setReason={AllPara.setReason}
        setPermissionAlertShow={AllPara.setPermissionAlertShow}
        setAlertConfirmOption={AllPara.setAlertConfirmOption}
        AlertConfirmOption={AllPara.AlertConfirmOption}
        isOpen={modal_xlargeV}
        toggle={tog_xlargeV}
        ProdCode={FormRow.strDET_PROCODE}
        CalculateVariantItemsTax={CalculateVariantItemsTax}
        priceModeSelect={priceModeSelect}
        ToLocation={toLocationSelect}
      />

      <TXNLineDetails
        mainTitle={`Line Remarks`}
        SubTitle={FormRow.strDET_PROCODE}
        Details={FormRow.strDET_PRODESC}
        DataRow={RemTbl}
        disabled={DisableDet}
        isOpen={modal_xlargeLine}
        toggle={tog_xlargeLine}
        SetRemTbl={SetRemTbl}
        LineNo={FormRow.id}
        setDetailRemarks={setDetailRemarks}
        DetailRemarks={detailLineRemarksNew}
        TaxLineRemarks={TaxLineRemarks}
        SetTaxLineRemarks={SetTaxLineRemarks}
      />
      <DPAlert
        confirm_both={sweetAlertShow}
        title={txn.strTX_DESC}
        description={AlertDescription}
        showCancel={sweetAlertShowCancel}
        btnColor={"success"}
        cancelColor={"danger"}

        onConfirm={() => {
          setsweetAlertShow(false)
          setsweetAlertShowCancel(false)
          //setcode("")

          if (detailAlertConfirmOption == 98) {
            setReasonForDetails(FormRow.strDET_REMCODE)
            addNewRowOnClickReason()
          }

          SetFocusToNextEmptyTextBox()
        }}
        onCancel={() => {
          setsweetAlertShow(false)
          setsweetAlertShowCancel(false)

          if (detailAlertConfirmOption == 98) {
            addNewRowOnClickReason()
          }

          SetFocusToNextEmptyTextBox()
        }}
        btnYes={"OK"}
      />
      <DPPermission
        confirm_both={detailAlertShow}
        title={menuName}
        description={detailPermissionAlertTitle}
        showReason={false}
        nameDisable={detailNameDisable}
        showCancel={detailShowCancel}
        btnColor={detailPermisonBtnColor}
        cancelColor={detailPermisonCancelColor}

        show={detailAlertResponseShow}
        AlertColor={detailAlertColor}
        AlertMsg={detailAlertMsg}

        AlName={detailPermissionUsername}
        AlNameOnchange={e => {
          let val2 = Text(e.target, 50, true, false, "any", false)
          setDetailPermissionUsername(val2)
        }}
        AlPassward={detailPermissionPassword}
        AlPasswardOnchange={e => {
          let val2 = Text(e.target, 50, true, true, "any", false)
          setDetailPermissionPassword(val2)
        }}
        AlReason={detailReason}
        AlReasonOnchange={e => {
          let val2 = Text(e.target, 50, true, false, "any", true)
          setDetailReason(val2)
        }}
        onConfirm={() => {

          setDetailPermissionAlertTitle("")
          if (detailAlertConfirmOption == 99) {
            MenuUserpermission("Access")
          } else if (detailAlertConfirmOption == 97) {
            MenuUserpermission("Access")
          } else if (detailAlertConfirmOption == 101) {
            MenuUserpermission("Access")
          } else if (detailAlertConfirmOption == 96) {
            MenuUserpermission("Access")
          }

        }}
        onCancel={() => {

          setDetailAlertShow(false)
          setDetailPermissionAlertTitle("")
          var currentRow = FormRow
          if (detailAlertConfirmOption == 99) {
            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)
          } else if (detailAlertConfirmOption == 97) {
            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)

            currentRow.dcDET_DISCAMT = priceModeSelect != "" ? 0 : parseFloat(FormRow.dcDET_DISCAMT).toFixed(txnDecimalAmt)
            currentRow.dcDET_DISCPER = priceModeSelect != "" ? 0 : parseFloat(FormRow.dcDET_DISCPER).toFixed(2)

          } else if (detailAlertConfirmOption == 101) {
            currentRow.dcDET_SPRICE = parseFloat(FormRow.dcDET_SPRICE_OLD).toFixed(txnDecimalAmt)
          } else if (detailAlertConfirmOption == 96) {
            currentRow.dcDET_UNITQTY = parseFloat(0).toFixed(currentRow.isDecimal == 1 ? txnDecimalQty : 0)
            currentRow.dcDET_CASEQTY = parseFloat(0).toFixed(0)
          }

          handleObjectChange(currentRow, FormRow.id) //set new values to the row object
        }}
      />

      <SOHViewModel
        isOpen={modelOpen_SOH}
        toggleModal={() => setmodelOpen_SOH(!modelOpen_SOH)}
        payload={soh_modelData}
      />

    </tr>
  )
}
//* end Single Row for TXN Details table */

const TableTaxRow = ({ FormRow, Key, txnDecimalAmt }) => {

  return (
    <tr key={FormRow.id}>
      <td style={{ width: "80px" }} id={"txtProCode" + Key}>
        {FormRow.proCode}
      </td>
      <td style={{ width: "200px" }} id={"txtProDesc" + Key} title={FormRow.proDesc}>
        {FormRow.proDesc != null ? FormRow.proDesc.replace(/(.{25})..+/, "$1...") : ""}
      </td>
      <td style={{ width: "50px" }} id={"txtTax" + Key}>
        {FormRow.taxCode}
      </td>
      <td
        style={{ width: "130px", textAlign: "right" }}
        id={"grossAmount" + Key}
      >
        {FormRow.grossAmt != null
          ? FormRow.grossAmt.toLocaleString(undefined, {
            maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt,
            minimumFractionDigits: 2,
          })
          : "0.00"}
      </td>
      <td
        style={{ width: "100px", textAlign: "right" }}
        id={"txtTaxRate" + Key}
      >
        {FormRow.taxRate != null
          ? FormRow.taxRate.toLocaleString(undefined, {
            maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt,
            minimumFractionDigits: 2,
          })
          : "0.00"}
      </td>
      <td style={{ width: "100px", textAlign: "center" }} id={"txtTaxInc" + Key}>
        {FormRow.taxInclusive ? "Inclusive" : "Exclusive"}
      </td>
      <td style={{ width: "100px", textAlign: "right" }} id={"txtTaxAmount" + Key}>
        {FormRow.taxAmount != null
          ? FormRow.taxAmount.toLocaleString(undefined, {
            maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt,
            minimumFractionDigits: 2,
          })
          : "0.00"}
      </td>
    </tr>
  )
}


const TableTaxSummary = ({ TaxTable, txnDecimalAmt }) => {

  const grouped = TaxTable.reduce((acc, curr) => {
    const key = `${curr.taxCode}`;
    if (!acc[key]) {
      acc[key] = {
        data: [],
        hed_Code: "",
        heD_RATE: 0,
        heD_INCLUSIVE: "",
        heD_TAX: 0,
      };
    }
    acc[key].data.push(curr);
    acc[key].hed_Code = curr.taxCode;
    acc[key].heD_RATE = curr.taxRate;
    acc[key].heD_INCLUSIVE = curr.taxInclusive
    acc[key].heD_TAX = acc[key].data.reduce((acc, curr) => acc + parseFloat(curr.taxAmount), 0)
    return acc;
  }, []);

  const result = Object.keys(grouped).map(key => {
    return grouped[key];
  });

  return (
    result.map((FormRow, Key) => (
      <tr key={Key}>
        <td style={{ width: "80px" }}>
          {FormRow.hed_Code}
        </td>
        <td style={{ width: "100px", textAlign: "right" }}>
          {FormRow.heD_RATE.toLocaleString(undefined, {
            maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt,
            minimumFractionDigits: 2,
          })}
        </td>
        <td style={{ width: "100px", textAlign: "right" }}>
          {FormRow.heD_INCLUSIVE == 1 ? "Inclusive" : "Exclusive"}
        </td>
        <td style={{ width: "150px", textAlign: "right" }}>
          {FormRow.heD_TAX.toLocaleString(undefined, {
            maximumFractionDigits: txnDecimalAmt < 2 ? 2 : txnDecimalAmt,
            minimumFractionDigits: 2,
          })}
        </td>
      </tr>
    ))
  )
}



